/*
 * Hauptlogik des Paws-Konfigurators.
 *
 * Lag bis zum Performance-Audit als rund 140 KB grosser Inline-Block in
 * snippets/paws-configurator.liquid und ging damit bei jedem einzelnen
 * Aufruf einer Konfigurator-Seite neu ueber die Leitung - ein Inline-Skript
 * kann der Browser nicht zwischenspeichern. Als Datei wird es einmal geladen
 * und danach aus dem Cache bedient.
 *
 * Die Werte, die frueher per Liquid eingesetzt wurden (Optionsnamen, deren
 * Indizes, Theme-Selektoren, Schalter), stehen jetzt im JSON-Block
 * #paws-config-data. Wer hier eine neue Einstellung braucht, ergaenzt sie
 * dort UND in der Zuweisung unten - fehlt sie an einer der beiden Stellen,
 * ist der Wert still undefined.
 *
 * Das Skript wird bewusst OHNE defer eingebunden, an genau der Stelle, an der
 * frueher der Inline-Block stand. Es greift unmittelbar auf das Markup ueber
 * ihm zu und meldet configurator_start; mit defer liefe es spaeter als bisher.
 */
(function () {
  const cfgEl = document.getElementById('paws-config-data');
  if (!cfgEl) return;
  const CFG = JSON.parse(cfgEl.textContent);
  // Positionen von Ausfuehrung, Groesse und Anzahl in variant.options.
  const F_IDX = CFG.fIdx;
  const S_IDX = CFG.sIdx;
  const Q_IDX = CFG.qIdx;

// V189: DYNAMIC OPTION NAMES FOR JS
const OPT_NAMES = {
   variant: CFG.lblVariant,
   size: CFG.lblSize
};
// Alle Optionsnamen in ihrer Reihenfolge - der Index passt zu variant.options.
const OPT_ALL = CFG.optAll;

const CONFIG = {
  isAutoNextDisabled: CFG.disableAutoNext,
  noAutoNextSteps: CFG.noAutoNextSteps.split(',').map(s => s.trim()).filter(Boolean),
  isBypassValidation: CFG.bypassValidation,
  showPetNames: CFG.showPetNames,
  selectors: { 
     price: CFG.selPrice, 
     comparePrice: CFG.selComparePrice, 
     atcButton: CFG.selAtcButton, 
     discountBadge: CFG.selDiscountBadge, 
     cartForm: CFG.selCartForm,
     variantPicker: CFG.selVariantPicker 
  }
};
const showPhonesActive = CFG.showPhones;
// V177: GLOBAL ID FOR SAFETY
let currentMainVariantId = CFG.variantId;
let currentPriceEur = null;

// Meldet an assets/paws-insights.js; laeuft das Skript noch nicht,
// wandert der Aufruf in eine Warteschlange.
const track = (name, payload) => {
  try {
    const daten = Object.assign({ configurator: 'paws', variant_id: currentMainVariantId, value: currentPriceEur }, payload || {});
    if (window.pawsInsights && window.pawsInsights.track) window.pawsInsights.track(name, daten);
    else (window.pawsInsightsQueue = window.pawsInsightsQueue || []).push([name, daten]);
  } catch (e) {}
};

// Adresszeile immer auf der aktuell gewaehlten Variante halten.
const syncUrlVariante = (id) => {
  try {
    if (window.pawsInsights && window.pawsInsights.syncVariantUrl) { window.pawsInsights.syncVariantUrl(id); return; }
    if (!id || !/^\d+$/.test(String(id))) return;
    const url = new URL(window.location.href);
    if (url.searchParams.get('variant') === String(id)) return;
    url.searchParams.set('variant', String(id));
    window.history.replaceState(window.history.state, '', url.toString());
  } catch (e) {}
};

const hideThemeElements = () => {
  const selectorsToHide = [
    CONFIG.selectors.price,
    CONFIG.selectors.comparePrice,
    CONFIG.selectors.atcButton,
    CONFIG.selectors.discountBadge,
    CONFIG.selectors.variantPicker
  ];

  selectorsToHide.forEach(selector => {
    if (selector && selector.trim() !== '') {
      try {
        document.querySelectorAll(selector).forEach(el => {
          if (el.style.display !== 'none') {
            el.style.display = 'none';
          }
        });
      } catch (e) {
        console.error(`PAWS Configurator: Invalid selector in settings: "${selector}"`);
      }
    }
  });
};

hideThemeElements();
window.addEventListener('load', hideThemeElements);
setTimeout(hideThemeElements, 500);
setTimeout(hideThemeElements, 1500);

// Die vier Spalten aus dem JSON-Block wieder zu der Objektliste
// zusammensetzen, mit der der Rest des Skripts seit jeher arbeitet.
// Reihenfolge und Werte sind identisch zu product.variants - nur die
// ungenutzten Felder fehlen. Faellt der Block wider Erwarten aus dem
// Rahmen, bleibt vData ein leeres Array statt zu werfen; dann greift
// in updatePrice() der bereits vorhandene Ersatzweg.
const vData = (() => {
  try {
    const roh = JSON.parse(document.getElementById('paws-variant-data').innerHTML);
    if (Array.isArray(roh)) return roh; // Rueckfall: alter Vollformat-Block
    return roh.id.map((id, i) => ({
      id: id,
      price: roh.price[i],
      compare_at_price: roh.compare_at_price[i],
      options: roh.options[i]
    }));
  } catch (e) { return []; }
})();
const vMap = JSON.parse(document.getElementById('paws-variant-map').innerHTML);
const master = document.getElementById('paws-configurator-wrapper');
// Aufgeloeste Bildtexte, einschliesslich sichtbarer Gravur-Platzhalter.
const gravurTexte = new Map();
const customAtcBtn = document.querySelector('.js-custom-atc-btn');
const warenkorbLink = document.querySelector('.paws-panel[data-type="summary"] .js-cart-only');
const productFormEl = master ? master.closest('form') : null;
const dotsTrack = document.querySelector('.js-dots-track');
let panels = Array.from(document.querySelectorAll('.js-panel'));
// V191: Filter out hidden panels (e.g., when variant has only 1 option)
panels = panels.filter(p => p.style.display !== 'none' && p.closest('[style*="display:none"]') === null);

// --- A/B-Test: Darstellungsvariante ---------------------------------
// Die Zuweisung passiert in layout/theme.liquid noch im <head>; hier
// wird sie nur gelesen. Variante B zeigt exakt dieselben Schritte,
// Felder und Werte auf EINER Seite. Es aendert sich nichts an den
// Feldnamen, an updatePrice/updateFinalSku oder an kaufAusfuehren -
// der Warenkorb-Payload ist damit bauartbedingt identisch.
const AB_VARIANTE = (window.PAWS_AB === 'B') ? 'B' : 'A';
const einseitig = AB_VARIANTE === 'B';

let currentIdx = 0;
let upsellMapping = {};
let activeUpsellProducts = {};
let selectedUpsells = new Set(); 
let isCustomAtcSubmitting = false;
// Merkt sich, ob zuletzt "zur Kasse" oder "in den Warenkorb" gewaehlt war,
// damit ein Wiederholversuch nach einem Fehler denselben Weg nimmt.
let letzterKaufWeg = true;

// Kommt der Kunde per Zurueck-Taste aus der Kasse, liegt seine Konfiguration
// bereits im Warenkorb - ein zweiter Klick darf sie kein zweites Mal hinzufuegen.
const KAUF_SPEICHER = 'pawsKonfigImWarenkorb';
const kaufBtnText = customAtcBtn ? customAtcBtn.textContent : '';
const warenkorbLinkText = warenkorbLink ? warenkorbLink.textContent : '';
let imWarenkorb = null;

const shopWurzel = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

const kaufSignatur = () => {
  const teile = [String(currentMainVariantId || '')];
  document.querySelectorAll('#paws-configurator-wrapper [name^="properties["], #paws-configurator-wrapper [name^="options["]').forEach(feld => {
    if (feld.closest('.js-text-line[hidden]')) return;
    if (feld.type === 'radio' || feld.type === 'checkbox') {
      if (feld.checked) teile.push(`${feld.name}=${feld.value}`);
    } else if (feld.type === 'file') {
      [...feld.files].forEach(datei => teile.push(`${feld.name}=${datei.name}:${datei.size}`));
    } else if (feld.value) {
      teile.push(`${feld.name}=${feld.value}`);
    }
  });
  teile.push('upsells=' + [...selectedUpsells].sort().join('|'));
  return teile.join('&');
};

const merkeKauf = (token) => {
  imWarenkorb = { token, sig: kaufSignatur() };
  try { sessionStorage.setItem(KAUF_SPEICHER, JSON.stringify(imWarenkorb)); } catch (e) {}
};

const vergissKauf = () => {
  imWarenkorb = null;
  try { sessionStorage.removeItem(KAUF_SPEICHER); } catch (e) {}
};

// Gilt nur, solange nichts umkonfiguriert wurde - sonst ist es ein neues Produkt.
const kaufGiltNoch = () => !!imWarenkorb && imWarenkorb.sig === kaufSignatur();

// Die Warenkorb-Lade von UpCart, sonst die des Themes - eine eigene Seite ist der Notnagel.
const warteKurz = (ms) => new Promise(r => setTimeout(r, ms));
const ladeOffen = () => document.body.classList.contains('upcartPopupShow');
const warenkorbOeffnen = async () => {
  // Nach dem Zurueck aus der Kasse laedt die Seite neu - UpCart meldet sich erst kurz danach.
  for (let i = 0; i < 8 && typeof window.upcartOpenCart !== 'function'; i++) await warteKurz(100);
  try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
  if (typeof window.upcartOpenCart === 'function') {
    try { window.upcartOpenCart(); } catch (e) {}
    for (let i = 0; i < 12; i++) {
      if (ladeOffen()) return true;
      await warteKurz(100);
    }
  }
  const schalter = document.querySelector('[aria-controls="CartDrawer"]');
  if (schalter) { schalter.click(); return true; }
  return false;
};

const textSetzen = (el, text) => { if (el && el.textContent !== text) el.textContent = text; };

const kaufModusAnzeigen = () => {
  if (isCustomAtcSubmitting) return;
  const schonDrin = kaufGiltNoch();
  textSetzen(customAtcBtn, schonDrin ? pawsText('atc_in_cart_checkout') : kaufBtnText);
  textSetzen(warenkorbLink, schonDrin ? pawsText('atc_in_cart_link') : warenkorbLinkText);
};

// In der Kasse kann der Artikel geloescht worden sein - dann zaehlt die Notiz nicht mehr.
const warenkorbAbgleichen = async () => {
  let notiz = null;
  try { notiz = JSON.parse(sessionStorage.getItem(KAUF_SPEICHER) || 'null'); } catch (e) {}
  if (!notiz || !notiz.token) { vergissKauf(); kaufModusAnzeigen(); return; }
  try {
    const antwort = await fetch(shopWurzel() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const korb = await antwort.json();
    const drin = (korb.items || []).some(pos => pos.properties && pos.properties.__paws_debug_token === notiz.token);
    if (drin) imWarenkorb = notiz; else vergissKauf();
  } catch (e) {
    // Im Zweifel der Notiz glauben: ein doppelter Kauf waere teurer als ein Umweg.
    imWarenkorb = notiz;
  }
  kaufModusAnzeigen();
};

const setInlineError = (msg, opts) => {
  const amButton = document.querySelector('.js-panel[data-type="summary"] .js-atc-error');
  const obenImWrapper = document.getElementById('paws-js-error-container');
  const summary = amButton && amButton.closest('.js-panel');
  // Oben im Konfigurator sieht der Kunde die Meldung nicht, wenn er unten kauft.
  const ziel = (summary && summary.getClientRects().length) ? amButton : obenImWrapper;

  [amButton, obenImWrapper].forEach(el => {
    if (el) { el.textContent = ''; el.style.display = 'none'; }
  });
  if (!ziel || !msg) return;

  const box = document.createElement('div');
  box.className = 'paws-inline-error';
  const text = document.createElement('span');
  text.textContent = msg;
  box.appendChild(text);

  if (opts && opts.erneut) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'paws-inline-error__retry';
    btn.textContent = pawsText('atc_retry');
    btn.addEventListener('click', () => kaufAusfuehren(letzterKaufWeg));
    box.appendChild(btn);
  }

  ziel.appendChild(box);
  ziel.style.display = 'block';
  try { ziel.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
};

// Grosse Handyfotos brauchen bis zur Vorschau spuerbar Zeit; ohne Rueckmeldung
// klicken Kunden in der Zwischenzeit mehrfach auf Auswaehlen.
const vorschauQuellen = new WeakMap();
const zeigeFotoVorschau = (card, datei) => {
  const box = card && card.querySelector('.js-preview-box');
  if (!box) return;
  const btnText = card.querySelector('.paws-upload-btn-ui span');
  const inhalt = card.querySelector('.paws-upload-content');

  const alteQuelle = vorschauQuellen.get(box);
  if (alteQuelle) URL.revokeObjectURL(alteQuelle);
  vorschauQuellen.delete(box);

  const alterHinweis = inhalt && inhalt.querySelector('.paws-upload-note');
  if (alterHinweis) alterHinweis.remove();

  box.textContent = '';
  box.style.backgroundImage = '';
  box.classList.remove('has-image');
  box.classList.add('is-loading');
  card.classList.add('is-busy');

  const beenden = () => {
    box.classList.remove('is-loading');
    card.classList.remove('is-busy');
    if (btnText) btnText.innerText = pawsText('upload_btn_change');
  };

  const url = URL.createObjectURL(datei);
  const bild = new Image();

  bild.onload = () => {
    beenden();
    box.style.backgroundImage = `url(${url})`;
    box.classList.add('has-image');
    vorschauQuellen.set(box, url);
  };

  bild.onerror = () => {
    // HEIC-Fotos vom iPhone kann der Browser nicht anzeigen, hochgeladen werden sie trotzdem.
    URL.revokeObjectURL(url);
    beenden();
    box.classList.add('has-image');
    box.innerHTML = '<svg class="paws-upload-check" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>';
    if (inhalt) {
      const hinweis = document.createElement('div');
      hinweis.className = 'paws-upload-note';
      hinweis.textContent = pawsText('upload_no_preview');
      inhalt.appendChild(hinweis);
    }
  };

  bild.src = url;
};

// Handyfotos sind oft 8-12 MB - fast die gesamte Wartezeit beim Kauf geht dafuer drauf.
// Bewusst vorsichtig: die Aufloesung bleibt bis 5000 px unangetastet, es wird nur die
// JPEG-Kompression neu gesetzt, und nur wenn das mindestens ein Viertel spart.
const FOTO_AB_BYTES = 5 * 1024 * 1024;
const FOTO_MAX_KANTE = 5000;
const FOTO_QUALITAET = 0.92;
const FOTO_MIN_ERSPARNIS = 0.25;

const fotoErsatz = new WeakMap();
const fotoArbeit = new WeakMap();

// Gedrehte Fotos (EXIF-Orientierung) fassen wir nicht an: ob ein Browser die Drehung
// beim Zeichnen anwendet, ist nicht einheitlich, und ein liegend gedrucktes Portrait
// waere teurer als jede gesparte Sekunde.
const exifOrientierung = async (datei) => {
  const puffer = await datei.slice(0, 131072).arrayBuffer();
  const daten = new DataView(puffer);
  if (daten.byteLength < 4 || daten.getUint16(0) !== 0xffd8) return null;
  let pos = 2;
  while (pos + 4 <= daten.byteLength) {
    if (daten.getUint8(pos) !== 0xff) return 1;
    const marke = daten.getUint8(pos + 1);
    const laenge = daten.getUint16(pos + 2);
    if (marke === 0xda || marke === 0xd9) return 1;
    if (marke === 0xe1 && pos + 10 <= daten.byteLength && daten.getUint32(pos + 4) === 0x45786966) {
      const tiff = pos + 10;
      if (tiff + 8 > daten.byteLength) return null;
      const klein = daten.getUint16(tiff) === 0x4949;
      const ifd = tiff + daten.getUint32(tiff + 4, klein);
      if (ifd + 2 > daten.byteLength) return null;
      const felder = daten.getUint16(ifd, klein);
      for (let i = 0; i < felder; i++) {
        const feld = ifd + 2 + i * 12;
        if (feld + 12 > daten.byteLength) return null;
        if (daten.getUint16(feld, klein) === 0x0112) return daten.getUint16(feld + 8, klein);
      }
      return 1;
    }
    pos += 2 + laenge;
  }
  return 1;
};

const FOTO_FORMATE = ['image/jpeg', 'image/png'];

// Ein PNG mit durchsichtigen Stellen darf nicht zu JPEG werden - Durchsichtig gaebe es
// dort nicht mehr. Die Pruefung laeuft auf einer 128px-Miniatur, das genuegt fuer
// Flaechen und kostet keine Rechenzeit.
const hatDurchsichtigeStellen = (bild) => {
  const probe = document.createElement('canvas');
  const faktor = Math.min(1, 128 / Math.max(bild.width, bild.height));
  probe.width = Math.max(1, Math.round(bild.width * faktor));
  probe.height = Math.max(1, Math.round(bild.height * faktor));
  const stift = probe.getContext('2d', { willReadFrequently: true });
  stift.drawImage(bild, 0, 0, probe.width, probe.height);
  const punkte = stift.getImageData(0, 0, probe.width, probe.height).data;
  probe.width = probe.height = 0;
  for (let i = 3; i < punkte.length; i += 4) {
    if (punkte[i] < 250) return true;
  }
  return false;
};

const fotoVerkleinern = async (datei) => {
  if (FOTO_FORMATE.indexOf(datei.type) === -1 || datei.size < FOTO_AB_BYTES) return null;
  if (typeof createImageBitmap !== 'function' || typeof datei.arrayBuffer !== 'function') return null;

  if (datei.type === 'image/jpeg') {
    const drehung = await exifOrientierung(datei);
    if (drehung === null || drehung > 1) return null;
  }

  const bild = await createImageBitmap(datei);
  let blob = null;
  try {
    if (datei.type !== 'image/jpeg' && hatDurchsichtigeStellen(bild)) return null;
    const faktor = Math.min(1, FOTO_MAX_KANTE / Math.max(bild.width, bild.height));
    const leinwand = document.createElement('canvas');
    leinwand.width = Math.round(bild.width * faktor);
    leinwand.height = Math.round(bild.height * faktor);
    const stift = leinwand.getContext('2d');
    stift.imageSmoothingQuality = 'high';
    // Weiss als Untergrund, falls doch eine feine durchsichtige Stelle durchgerutscht ist.
    stift.fillStyle = '#ffffff';
    stift.fillRect(0, 0, leinwand.width, leinwand.height);
    stift.drawImage(bild, 0, 0, leinwand.width, leinwand.height);
    blob = await new Promise(fertig => leinwand.toBlob(fertig, 'image/jpeg', FOTO_QUALITAET));
    leinwand.width = leinwand.height = 0;
  } finally {
    if (bild.close) bild.close();
  }

  if (!blob || blob.size > datei.size * (1 - FOTO_MIN_ERSPARNIS)) return null;
  const name = datei.name.replace(/\.[^.]+$/, '') + '.jpg';
  return new File([blob], name, { type: 'image/jpeg', lastModified: datei.lastModified });
};

const fotoVorbereiten = (feld, datei) => {
  const arbeit = fotoVerkleinern(datei).then(kleiner => {
    if (kleiner && feld.files[0] === datei) fotoErsatz.set(feld, kleiner);
  }).catch(fehler => {
    // Im Zweifel geht das Original raus - der Kauf darf daran nie scheitern.
    console.warn('PAWS Konfigurator: Foto konnte nicht verkleinert werden', fehler);
  });
  fotoArbeit.set(feld, arbeit);
};

const fotosAbwarten = () => Promise.all(
  [...document.querySelectorAll('#paws-configurator-wrapper input[type="file"]')]
    .map(feld => fotoArbeit.get(feld))
    .filter(Boolean)
);

panels.forEach(() => { 
    const d = document.createElement('div'); 
    d.className = 'paws-dot'; 
    dotsTrack.appendChild(d); 
});
const dots = document.querySelectorAll('.paws-dot');

const disableNativeCheckoutControls = () => {
  // Jede Schreiboperation erzeugt einen MutationRecord - auch wenn sich der Wert
  // nicht aendert. Ohne diese Guards feuert der Observer unten sich selbst endlos.
  const setStyleOnce = (el, prop, value) => {
    if (el.style[prop] !== value) el.style[prop] = value;
  };
  const setAttrOnce = (el, name, value) => {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  };

  const disableEl = (el, hide = true) => {
    if (!el || el === customAtcBtn) return;
    try {
      if ('disabled' in el && el.disabled !== true) el.disabled = true;
      setAttrOnce(el, 'aria-disabled', 'true');
      setStyleOnce(el, 'pointerEvents', 'none');
      if (hide) setStyleOnce(el, 'display', 'none');
    } catch (e) {}
  };

  if (productFormEl) {
    productFormEl.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(el => disableEl(el, true));
    productFormEl.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"], shopify-accelerated-checkout').forEach(el => {
      setAttrOnce(el, 'aria-hidden', 'true');
      setStyleOnce(el, 'pointerEvents', 'none');
      setStyleOnce(el, 'display', 'none');
    });
  }

  [CONFIG.selectors.atcButton, CONFIG.selectors.cartForm].forEach(selector => {
    if (!selector || selector.trim() === '') return;
    try {
      document.querySelectorAll(selector).forEach(el => {
        if (el.matches('button, input[type="submit"], input[type="button"]')) {
          disableEl(el, true);
        } else {
          el.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(btn => disableEl(btn, true));
        }
      });
    } catch (e) {
      console.error(`PAWS Configurator: Invalid native-control selector: "${selector}"`);
    }
  });
};

disableNativeCheckoutControls();
window.addEventListener('load', disableNativeCheckoutControls);
setTimeout(disableNativeCheckoutControls, 500);
setTimeout(disableNativeCheckoutControls, 1500);

if (productFormEl) {
  productFormEl.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    return false;
  }, true);
}

if (master) {
  master.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;
    if (!master.contains(target)) return;

    const tag = target.tagName.toLowerCase();
    const type = (target.getAttribute('type') || '').toLowerCase();
    const isTextInput = tag === 'input' && ['text', 'search', 'email', 'tel', 'url', 'number', ''].includes(type);

    if (isTextInput) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
}

const observerTarget = productFormEl || document.body;
if (observerTarget) {
  let pendingSync = false;
  let runsInWindow = 0;
  let windowStart = 0;
  const nativeControlObserver = new MutationObserver(() => {
    if (pendingSync) return;
    pendingSync = true;
    requestAnimationFrame(() => {
      pendingSync = false;
      const now = Date.now();
      if (now - windowStart > 1000) { windowStart = now; runsInWindow = 0; }
      // Notbremse: sollte trotz der Guards oben je wieder eine Rueckkopplung
      // entstehen, friert lieber der Sync ein als der ganze Tab.
      if (++runsInWindow > 30) {
        nativeControlObserver.disconnect();
        console.warn('PAWS Configurator: native-control observer gestoppt (Schleifenschutz).');
        return;
      }
      hideThemeElements();
      disableNativeCheckoutControls();
    });
  });
  nativeControlObserver.observe(observerTarget, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'disabled']
  });
}

const updateWormIndicator = () => {
     dots.forEach((d, i) => d.classList.toggle('active', i === currentIdx));
     const dotSize = 8, gap = 8, activeWidth = 20, viewportWidth = 72, maskBuffer = 10;
     const totalDots = dots.length;
     const totalTrackWidth = (totalDots * dotSize) + ((totalDots - 1) * gap) + (activeWidth - dotSize);
     let translateVal = 0;
     if (currentIdx === 0) translateVal = maskBuffer;
     else if (currentIdx === totalDots - 1) translateVal = viewportWidth - totalTrackWidth - maskBuffer;
     else {
        const centerOfActiveDotInTrack = (currentIdx * (dotSize + gap)) + (activeWidth / 2);
        const viewportCenter = viewportWidth / 2;
        translateVal = viewportCenter - centerOfActiveDotInTrack;
     }
     dotsTrack.style.transform = `translateX(${translateVal}px)`;
};

const loadUpsells = async () => {
  try {
    // Liquid-Asset-URL statt fest verdrahteter Produktionsdomain: traegt Shopifys eigene
    // Versionsquery, die der CDN-Cache tatsaechlich beachtet (der alte "?t=" wurde ignoriert).
    const upsellUrl = CFG.upsellUrl || 'https://www.pawslife.de/cdn/shop/t/53/assets/upsell_v1.json';
    const res = await fetch(upsellUrl);
    upsellMapping = await res.json();
    
    const promises = [];
    for (const handle in upsellMapping) {
      if (handle === '__bundles') continue;
      const item = upsellMapping[handle];
      if (item.configurator_summary_upsell || item.configurator_page_upsell) {
        promises.push(
          fetch(`/products/${handle}.js`)
            .then(r => r.json())
            .then(data => {
               activeUpsellProducts[handle] = data;
               // V169: TURBO RESIZE - _600x
               if (data.featured_image) {
                   const optimizedUrl = data.featured_image.replace(/(\.[^.]*)(\?v=.*)?$/, '_600x$1$2');
                   data.featured_image = optimizedUrl; // Override for UI
                   (new Image()).src = optimizedUrl; // Preload resized
               }
            })
            .catch(e => {})
        );
      }
    }

    if (upsellMapping['__bundles']) {
       for (const bundleDef of upsellMapping['__bundles']) {
          if (bundleDef.bundle_product_handle) {
             promises.push(
                fetch(`/products/${bundleDef.bundle_product_handle}.js`)
                .then(r => r.json())
                .then(data => {
                   activeUpsellProducts[bundleDef.bundle_product_handle] = data;
                   // V169: TURBO RESIZE FOR BUNDLES TOO
                   if (data.featured_image) {
                       const optimizedUrl = data.featured_image.replace(/(\.[^.]*)(\?v=.*)?$/, '_600x$1$2');
                       data.featured_image = optimizedUrl;
                       (new Image()).src = optimizedUrl;
                   }
                })
                .catch(e => {})
             );
          }
       }
    }
    
    await Promise.all(promises);
    render(false, 0); 

  } catch(e) {}
};
loadUpsells();

// Bilder spaeterer Schritte vorwaermen. Beides gehoert in den
// Leerlauf: waehrend der Startphase konkurriert jeder zusaetzliche
// Download mit dem grossen Produktbild, an dem der Kunde die
// Ladezeit misst (LCP). fetchPriority sagt dem Browser zusaetzlich,
// dass er diese Bilder hinten anstellen darf.
const warmUrl = (url) => {
  if (!url) return;
  const bild = new Image();
  try { bild.fetchPriority = 'low'; } catch (e) {}
  bild.decoding = 'async';
  bild.src = url;
};

// Hintergruende und Markenlogos - die Adressen stehen im JSON-Block
// und sind identisch zu denen im Markup.
const preloadStaticImages = () => {
   const dataEl = document.getElementById('paws-preload-data');
   if (!dataEl) return;
   try {
     JSON.parse(dataEl.innerHTML).forEach(warmUrl);
   } catch (e) {}
};

// Die Farbfelder stecken als background-image in einem display:none-Panel
// und wuerden sonst erst beim Wechsel auf den Farbschritt geladen. Die
// Adresse kommt direkt aus dem DOM, trifft also immer den Cache.
const preloadSwatchImages = () => {
   document.querySelectorAll('.paws-swatch-item label').forEach(l => {
      const m = l.style.backgroundImage.match(/url\(["']?([^"')]+)["']?\)/);
      if (m) warmUrl(m[1]);
   });
};

const vorwaermen = () => { preloadStaticImages(); preloadSwatchImages(); };
if ('requestIdleCallback' in window) requestIdleCallback(vorwaermen, { timeout: 2500 });
else setTimeout(vorwaermen, 1500);

// --- FARBE -> PRODUKTBILD ---
// Zuordnung ueber den Alt-Text des Produktbildes. Erlaubt sind
//   "Schwarz"                -> exakter Farbname
//   "farbe:Schwarz | Urne"   -> Praefix, Rest bleibt fuer SEO frei
// Findet sich kein passendes Bild, passiert schlicht nichts - deshalb
// ist das fuer alle Bestandsprodukte ohne solche Alt-Texte wirkungslos.
const normalizeColorKey = (value) => (value || '').toString().trim().toLowerCase();

const buildColorMediaMap = () => {
  const map = {};
  if (typeof window.pawsGalleryMedia !== 'function') return map;
  window.pawsGalleryMedia().forEach(media => {
    const alt = (media.alt || '').trim();
    if (!alt) return;
    let key = '';
    const lower = alt.toLowerCase();
    const prefixAt = lower.indexOf('farbe:');
    if (prefixAt !== -1) {
      key = normalizeColorKey(alt.slice(prefixAt + 6).split('|')[0]);
    } else {
      key = normalizeColorKey(alt);
    }
    // Das erste passende Bild gewinnt, damit die Reihenfolge im Admin entscheidet.
    if (key && !map[key]) map[key] = media.id;
  });
  return map;
};

let colorMediaMap = buildColorMediaMap();

const showMediaForSelectedColor = (instant = false) => {
  const checked = document.querySelector('.js-color-trigger:checked');
  if (!checked) return;
  const mediaId = colorMediaMap[normalizeColorKey(checked.value)];
  if (!mediaId || typeof window.pawsShowGalleryMedia !== 'function') return;
  window.pawsShowGalleryMedia(mediaId, { instant: instant });
};

// ext-main-product.js laeuft auf DOMContentLoaded und ist beim Ausfuehren
// dieses Inline-Skripts noch nicht zwingend fertig.
document.addEventListener('paws:gallery-ready', () => {
  colorMediaMap = buildColorMediaMap();
  showMediaForSelectedColor(true);
});

// V160: DEBUG FUNCTION
const renderDebugProperties = () => {
   const debugBox = document.getElementById('paws-debug-content');
   if (!debugBox) return;

   const collectedProps = {};
   document.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach(el => {
      const name = el.getAttribute('name');
      const cleanKey = name.replace('properties[', '').replace(']', '');
      
      if (el.type === 'radio' || el.type === 'checkbox') {
         if (el.checked) collectedProps[cleanKey] = el.value;
      } else if (el.type === 'file') {
         if (el.files.length > 0) collectedProps[cleanKey] = `[FILE: ${el.files[0].name}]`;
      } else {
         if (el.value) collectedProps[cleanKey] = el.value;
      }
   });

   debugBox.innerText = JSON.stringify(collectedProps, null, 2);
};

// V163: UPDATE FINAL MODEL (New Logic)
const updateFinalModel = () => {
    if (!showPhonesActive) return;
    
    // Find the visible dropdown
    const activeDropdown = document.querySelector('.js-brand-models-wrapper[style*="block"] .js-model-selector');
    const hiddenInput = document.querySelector('.js-final-model-input');
    
    if (activeDropdown && hiddenInput) {
       hiddenInput.value = activeDropdown.value;
    } else if (hiddenInput) {
       hiddenInput.value = ""; 
    }
};

// V161: FINAL SKU UPDATE FUNCTION (V162 FIX: NO FALLBACK)
const updateFinalSku = () => {
   const skuInput = document.querySelector('.js-final-sku-input');
   const qtyInput = document.querySelector('.js-anz-trigger:checked');
   const qty = qtyInput ? parseInt(qtyInput.value.match(/\d+/)[0]) : 1;

   // 1. PHONE CASE LOGIC
   if (showPhonesActive) {
       const phoneSelect = document.querySelector('.js-brand-models-wrapper[style*="block"] .js-model-selector');
       const phoneOption = phoneSelect ? phoneSelect.options[phoneSelect.selectedIndex] : null;
       const phoneCode = phoneOption ? phoneOption.dataset.skuCode : '';
       const styleId = CFG.skuStyleId;

       if(phoneCode && styleId && styleId != "0") {
          skuInput.value = `${phoneCode}-${styleId}-Q${qty}`;
          skuInput.disabled = false;
          return;
       }
   }
   
   // 2. V186: BACKGROUND SKU LOGIC
   const bgInput = document.querySelector('.js-bg-sku-size');
   const bgStyleInput = document.querySelector('.js-bg-sku-style');
   
   if (bgInput && bgStyleInput && bgInput.value && bgStyleInput.value) {
        const bgSkuSize = bgInput.value;
        const bgSkuStyle = bgStyleInput.value;
        skuInput.value = `${bgSkuSize}-${bgSkuStyle}-Q${qty}`;
        skuInput.disabled = false;
        return;
   }

   // 3. Fallback: Disable
   if(skuInput) {
      skuInput.value = "";
      skuInput.disabled = true;
   }
};

// Variante B hat keine Weiter-Knoepfe. Dieselbe Pflichtpruefung sperrt
// dort stattdessen den Kaufbutton - fachlich identisch zu Variante A,
// inklusive der Regel, dass ein als Pflicht markiertes Freitextfeld auch
// bei aktivem bypass_validation blockiert.
const validateEinseitig = () => {
  if (!customAtcBtn || isCustomAtcSubmitting) return;
  const fehlt = [...document.querySelectorAll('#paws-configurator-wrapper .js-paws-text-input[data-required="true"]')]
    .some(el => !el.closest('.js-text-line[hidden]') && el.value.trim() === '');
  if (customAtcBtn.disabled !== fehlt) customAtcBtn.disabled = fehlt;
};

const validatePanel = () => {
  if (einseitig) { validateEinseitig(); return; }
  const p = panels[currentIdx]; if (!p) return;
  const b = p.querySelector('.js-btn-next'); if (!b) return;
  // Ein explizit als Pflicht markiertes Freitextfeld gilt auch bei aktivem Bypass.
  const eng = p.querySelector('.js-paws-text-input[data-required="true"]');
  const engMissing = !!eng && eng.value.trim() === '';
  if (CONFIG.isBypassValidation) { b.disabled = engMissing; return; }
  let valid = [...new Set([...p.querySelectorAll('input[type="radio"]')].map(r => r.name))].every(n => [...p.querySelectorAll(`input[name="${n}"]`)].some(r => r.checked));
  
  // V171: Allow button to be active on phone panel if brand is selected (to show alert)
  if (valid && p.dataset.type !== 'phones') {
     valid = [...p.querySelectorAll('select:not([disabled])')].every(s => s.value !== "");
  } else if (p.dataset.type === 'phones') {
     // For phones, valid is purely based on radio (brand), select is ignored here (checked on click)
  } else {
     if (valid) valid = [...p.querySelectorAll('select:not([disabled])')].every(s => s.value !== "");
  }
  
  if (valid && p.dataset.type === 'personalization') valid = true; 
  if (valid && engMissing) valid = false;
  b.disabled = !valid;
};

// Aufpreis bzw. Ersparnis jeder Groessenkachel, gemessen an der
// aktuell gewaehlten Groesse. Reine Anzeige: es wird ausschliesslich
// Text in ein eigenes <span> geschrieben, nie ein Formularwert, keine
// Varianten-ID und kein input[name="id"] - der /cart/add.js-Payload
// bleibt dadurch unveraendert.
// Texte kommen aus dem globalen Bund (assets/paws-texte.js, von
// ui_translations ueberschreibbar) - keine eigenen Rueckfalltexte hier.
// Eckband "Bestseller" auf den meistgewaehlten Kacheln.
//
// Quelle ist ausschliesslich das Metafeld custom.configurator_bestseller.
// Aufbau: { "_immer": [...], "<ausfuehrung>": [...] }. Werte unter _immer
// gelten dauerhaft, alle uebrigen Schluessel nur, solange genau diese
// Ausfuehrung gewaehlt ist - bei Hochkantformaten heisst dieselbe Groesse
// auf Leinwand "50x75cm" und auf Poster "50x70cm", ein fester Eintrag waere
// dort in der Haelfte der Faelle falsch.
//
// Bewusst NUR eine Klasse: die Vorauswahl (checked), die Reihenfolge der
// Kacheln und der Warenkorb-Payload bleiben unberuehrt. Das Band ist reine
// Auszeichnung, keine Entscheidung.
//
// Verglichen wird gegen Optionswerte, nie gegen Optionsnamen: Shopify
// uebersetzt die Namen ("Größe" -> "Taille"), die Werte aber nicht. Ein
// Vergleich gegen Namen fiele auf /fr/ und /nl/ still aus.
const BESTSELLER = (CFG.bestseller && typeof CFG.bestseller === 'object') ? CFG.bestseller : null;
const bsNorm = (wert) => String(wert === undefined || wert === null ? '' : wert).trim().toLowerCase();

const bestsellerWerte = () => {
  const raus = [];
  const sammeln = (liste) => {
    if (Array.isArray(liste)) liste.forEach(w => { const n = bsNorm(w); if (n) raus.push(n); });
  };
  sammeln(BESTSELLER._immer);
  // Schluessel mit fuehrendem Unterstrich steuern nur - sie sind kein
  // Optionswert und duerfen nie als Ausfuehrung gelesen werden.
  const f = bsNorm(document.querySelector(`input[name="options[${OPT_NAMES.variant}]"]:checked`)?.value);
  if (f) {
    Object.keys(BESTSELLER).forEach(k => {
      if (k.charAt(0) === '_') return;
      if (bsNorm(k) === f) sammeln(BESTSELLER[k]);
    });
  }
  return raus;
};

const markiereBestseller = () => {
  if (!BESTSELLER) return;
  const werte = bestsellerWerte();
  // Nur die Ausfuehrungs- und Groessenschritte. Schrift-, Anzahl- und
  // Upsellkacheln tragen dieselbe Klasse .paws-card, fuehren aber ganz
  // andere Werte - ohne diese Eingrenzung koennte ein gleichlautender
  // Schriftname zufaellig ein Band bekommen.
  document.querySelectorAll('.js-panel[data-type="variant"] .paws-card').forEach(card => {
    const inp = card.querySelector('input[type="radio"]');
    const soll = !!inp && werte.indexOf(bsNorm(inp.value)) !== -1;
    // Erst pruefen, dann schreiben - ein blindes Setzen bei jedem
    // Tastendruck erzwaenge unnoetiges Re-Layout.
    if (card.classList.contains('is-bestseller') !== soll) card.classList.toggle('is-bestseller', soll);
  });
};

// Der Text steht als CSS-Eigenschaft am Wrapper, nicht als eigenes Element
// in jeder Kachel: das spart pro Kachel einen DOM-Knoten und haelt die
// Ausgabe des custom_liquid-Blocks unveraendert klein. JSON.stringify
// liefert die Anfuehrungszeichen mit, die content: in CSS verlangt.
const bestsellerTextSetzen = () => {
  if (!BESTSELLER) return;
  const wrapper = document.getElementById('paws-configurator-wrapper');
  const txt = typeof pawsText === 'function' ? pawsText('bestseller_badge') : '';
  if (wrapper && txt) wrapper.style.setProperty('--paws-bs-text', JSON.stringify(txt));
};

const updateSizeDeltas = () => {
  if (S_IDX === -1) return;
  const karten = document.querySelectorAll('.js-size-card');
  if (!karten.length) return;

  const f = document.querySelector(`input[name="options[${OPT_NAMES.variant}]"]:checked`)?.value;
  const q = document.querySelector('.js-anz-trigger:checked')?.value;
  // Ausfuehrung und Anzahl bleiben fest - verglichen wird nur die
  // Groesse, sonst waere die Differenz nicht die, die der Kunde beim
  // Klick tatsaechlich bezahlt.
  const variantFuer = (groesse) => {
    if (!groesse) return null;
    let c = vData;
    if (F_IDX !== -1 && f) c = c.filter(v => v.options[F_IDX] === f);
    if (Q_IDX !== -1 && q) c = c.filter(v => v.options[Q_IDX] === q);
    c = c.filter(v => v.options[S_IDX] === groesse && typeof v.price === 'number');
    return c.length ? c[0] : null;
  };

  const aktuellWert = document.querySelector(`input[name="options[${OPT_NAMES.size}]"]:checked`)?.value;
  const basisVar = variantFuer(aktuellWert);
  const basis = basisVar ? basisVar.price / 100 : null;
  // Ersparnis gegenueber dem Streichpreis. Fehlt compare_at_price oder
  // liegt er nicht ueber dem Preis, gibt es schlicht keine Ersparnis -
  // dann bleibt die Bonuszeile leer statt eine Null zu behaupten.
  const ersparnis = (v) => {
    if (!v || typeof v.compare_at_price !== 'number') return 0;
    const d = (v.compare_at_price - v.price) / 100;
    return d > 0 ? d : 0;
  };
  const basisErsparnis = ersparnis(basisVar);
  // Runde Betraege ohne Nachkommastellen: "+ 20 EUR" liest sich
  // schneller als "+ 20,00 EUR", krumme Betraege bleiben exakt.
  const euro = (n) => n.toLocaleString('de-DE', {
    style: 'currency', currency: 'EUR',
    minimumFractionDigits: Math.round(n * 100) % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2
  });

  karten.forEach(card => {
    const ziel = card.querySelector('.js-size-delta');
    const bonusZiel = card.querySelector('.js-size-bonus');
    if (!ziel) return;
    const v = variantFuer(card.dataset.sizeVal);
    const p = v ? v.price / 100 : null;
    let txt = '', klasse = '', bonusTxt = '';
    if (p !== null && basis !== null) {
      // Auf Cent runden, sonst erzeugt Fliesskomma-Arithmetik "+0,00 EUR".
      const d = Math.round((p - basis) * 100) / 100;
      if (d > 0) {
        txt = '+ ' + euro(d); klasse = 'is-plus';
        // Der Aufpreis kostet - der wachsende Rabatt gibt etwas
        // zurueck. Erst ab einem sichtbaren Betrag zeigen, sonst
        // wirkt die Zeile wie Kleingedrucktes.
        const mehr = Math.round(ersparnis(v) - basisErsparnis);
        if (mehr >= 3) bonusTxt = pawsText('size_delta_bonus', { betrag: euro(mehr) });
      }
      else if (d < 0) { txt = '\u2212 ' + euro(Math.abs(d)); klasse = 'is-minus'; }
      // d === 0 an einer anderen Kachel hiesse: gleiche Groesse zum
      // gleichen Preis - dann ist "ohne Aufpreis" die Nachricht.
      // An der gewaehlten Kachel selbst bleibt es bewusst leer.
      else if (card.dataset.sizeVal !== aktuellWert) {
        txt = pawsText('size_delta_zero'); klasse = 'is-null';
      }
    }
    // Erst pruefen, dann schreiben: ein blindes Setzen bei jedem
    // Tastendruck erzwaenge unnoetiges Re-Layout.
    if (ziel.textContent !== txt) ziel.textContent = txt;
    if (ziel.dataset.state !== klasse) {
      ziel.dataset.state = klasse;
      ziel.className = 'paws-size-delta js-size-delta' + (klasse ? ' ' + klasse : '');
    }
    if (bonusZiel && bonusZiel.textContent !== bonusTxt) bonusZiel.textContent = bonusTxt;
  });
};

// B1: Ersparnis-Chip neben dem Preis der Kaufleiste. Bewusst eine
// eigene Marke statt .js-paws-savings: jene Anzeige ist in der
// Zusammenfassung absichtlich stumm (und damit in Variante B immer),
// der Chip soll aber gerade dort stehen.
const setzeSparChip = (pct) => {
  const zeigen = pct > 0;
  const txt = zeigen ? ('\u2212' + pct + '\u00A0%') : '';
  document.querySelectorAll('.js-save-chip').forEach(el => {
    if (el.textContent !== txt) el.textContent = txt;
    if (el.hidden === zeigen) el.hidden = !zeigen;
  });
};

// Eine Bewertung, eine Quelle: Note und Kundenzahl kommen aus dem
// globalen Trustpilot-Badge. Faellt es weg, bleibt der im Markup
// hinterlegte Rueckfall stehen - eine leere Stelle waere schlimmer
// als ein leicht veralteter Wert.
const uebertragen = (auswahl, wert) => {
  if (!wert) return;
  document.querySelectorAll(auswahl).forEach(el => { if (el.textContent !== wert) el.textContent = wert; });
};
const vertrauenUebernehmen = () => {
  const badge = document.querySelector('.pw-trust-container');
  if (!badge) return false;
  const note = badge.querySelector('.pw-mb-score, .pw-rating-score');
  const m = note && String(note.textContent || '').match(/\d+[.,]\d+|\d+/);
  if (!m) return false;
  uebertragen('.js-trust-score', m[0].replace('.', ','));
  // Im Badge steht die Zahl mal allein ("24.000+"), mal mit Wort
  // ("24.000+ Kunden") - das Wort steht im Konfigurator schon daneben.
  const anzahl = badge.querySelector('.pw-mb-count, .pw-dt-count');
  if (anzahl) uebertragen('.js-trust-count', String(anzahl.textContent || '').trim().split(/\s+/)[0]);
  return true;
};

// Zufriedenheitsgarantie: die Karte im letzten Schritt wird zur Laufzeit
// aus assets/paws-texte.js gebaut, damit kein Text im Snippet
// festgeschrieben ist und Uebersetzungen aus ui_translations weiter
// gewinnen. Fehlen die Texte, bleibt die bisherige Vertrauensliste aus
// dem Metaobject unveraendert stehen.
// init() laeuft zweimal, das hier muss also wiederholbar sein.
const garantieAufbauen = () => {
  const karte = document.querySelector('.paws-panel[data-type="summary"] .paws-summary-card');
  const titel = pawsText('guarantee_headline');
  const schritte = pawsTextListe('guarantee_steps');
  // Die Karte wird ersetzt, nicht ergaenzt: zwei Vertrauensflaechen
  // direkt untereinander sind Rauschen.
  if (!karte || karte.dataset.garantie === 'ja' || !titel || schritte.length === 0) return;

  const kopf = document.createElement('p');
  kopf.className = 'paws-guarantee-card__title';
  kopf.textContent = titel;
  const liste = document.createElement('ol');
  liste.className = 'paws-guarantee-steps';
  schritte.forEach((satz, i) => {
    const zeile = document.createElement('li');
    const nr = document.createElement('span');
    nr.className = 'paws-guarantee-steps__num';
    nr.setAttribute('aria-hidden', 'true');
    nr.textContent = String(i + 1);
    const text = document.createElement('span');
    text.textContent = satz;
    zeile.append(nr, text);
    liste.appendChild(zeile);
  });
  karte.replaceChildren(kopf, liste);

  const hinweis = pawsText('guarantee_note');
  if (hinweis) {
    const p = document.createElement('p');
    p.className = 'paws-guarantee-card__note';
    p.textContent = hinweis;
    karte.appendChild(p);
  }
  karte.classList.add('paws-summary-card--guarantee');
  karte.dataset.garantie = 'ja';
};

const updatePrice = () => {
  // V189: DYNAMIC SELECTORS
  const f = document.querySelector(`input[name="options[${OPT_NAMES.variant}]"]:checked`)?.value;
  const s = document.querySelector(`input[name="options[${OPT_NAMES.size}]"]:checked`)?.value;
  const q = document.querySelector('.js-anz-trigger:checked')?.value;
  
  let candidates = vData;
  if (F_IDX !== -1 && f) candidates = candidates.filter(v => v.options[F_IDX] === f);
  if (S_IDX !== -1 && s) candidates = candidates.filter(v => v.options[S_IDX] === s);
  if (Q_IDX !== -1 && q) candidates = candidates.filter(v => v.options[Q_IDX] === q);

  const matched = candidates.length > 0 ? candidates[0] : null;

  if (matched) {
    let p = matched.price / 100;
    let cp = matched.compare_at_price ? matched.compare_at_price / 100 : 0;
    document.querySelectorAll('.js-upsell-checkbox:checked, .js-page-upsell-radio:checked').forEach(cb => { 
      const handle = cb.dataset.key; const up = activeUpsellProducts[handle]; 
      if (up) { p += up.price / 100; if (up.compare_at_price) cp += up.compare_at_price / 100; } 
    });
    // In Variante B ist die Zusammenfassung immer sichtbar, also gelten
    // dort dauerhaft deren Regeln (Rabatt-Badge aus, Review neu zeichnen).
    const isSummary = einseitig || panels[currentIdx]?.dataset.type === 'summary';
    const pct = (cp > p) ? Math.round(((cp - p) / cp) * 100) : 0;
    document.querySelectorAll('.js-paws-savings').forEach(el => { el.textContent = `-${pct}%`; el.style.display = (pct > 0 && !isSummary) ? "inline-block" : "none"; });
    // B1: derselbe Prozentwert, nur an anderer Stelle - kein zweiter
    // Rechenweg. Die Leiste zeigt ihn auch in der Zusammenfassung,
    // weil dort der Streichpreis direkt daneben steht.
    setzeSparChip(pct);
    document.querySelectorAll('.js-paws-current').forEach(el => el.textContent = p.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }));
    document.querySelectorAll('.js-paws-compare').forEach(el => { el.textContent = cp > 0 ? cp.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) : ""; el.style.display = cp > 0 ? "inline" : "none"; });
    document.querySelectorAll('.js-urgency-pct').forEach(el => el.textContent = `-${pct}%`);
    // Leerer String statt fester Wert: die Box ist per CSS display:flex.
    const urgencyDisplay = pct > 0 ? '' : 'none';
    document.querySelectorAll('.js-urgency-banner').forEach(el => { if (el.style.display !== urgencyDisplay) el.style.display = urgencyDisplay; });
    
    // V177: UPDATE GLOBAL ID INSTEAD OF DOM
    currentMainVariantId = matched.id;
    currentPriceEur = p;
    syncUrlVariante(matched.id);
    if (isSummary) renderReview();
    
    // Optional: Update DOM if exists (for compatibility with other apps)
    try {
       const domInput = document.querySelector('input[name="id"]');
       if (domInput) domInput.value = matched.id;
    } catch(e) {}
  } else {
    // Passt keine Kombination (z.B. weil ein Schritt gar nicht
    // gezeichnet wurde und deshalb keine Kachel angehakt ist), stand
    // bisher gar nichts im Preisfeld - der Konfigurator wirkte
    // preislos. Ersatzweise wird der guenstigste lieferbare Preis
    // angezeigt. Variante, Warenkorb-ID und syncUrlVariante bleiben
    // bewusst unberuehrt, damit der /cart/add.js-Payload identisch
    // bleibt.
    const ersatz = (Array.isArray(vData) ? vData.filter(v => v && typeof v.price === 'number') : []).sort((a, b) => a.price - b.price)[0];
    if (ersatz) {
      const p = ersatz.price / 100;
      document.querySelectorAll('.js-paws-current').forEach(el => el.textContent = p.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }));
      document.querySelectorAll('.js-paws-compare').forEach(el => { el.textContent = ""; el.style.display = "none"; });
      document.querySelectorAll('.js-paws-savings').forEach(el => { el.style.display = "none"; });
    }
    setzeSparChip(0);
  }

  // Immer - auch im Rueckfall, denn die Differenzen zwischen den
  // Groessen stimmen selbst dann, wenn keine Gesamtkombination passt.
  updateSizeDeltas();
  // Haengt an derselben Stelle, weil sich beides aus derselben Auswahl
  // ergibt: welche Groesse Bestseller ist, haengt an der Ausfuehrung.
  markiereBestseller();
};

const updatePetFields = () => {
  const checked = document.querySelector('.js-anz-trigger:checked');
  // V182: DEFAULT TO 1 IF NO CHECKBOX FOUND
  let count = 1;
  if (checked) {
     // Werte ohne Ziffer ("Einzeln", "Paar") liefern null -> parseInt
     // ergaebe NaN und "idx < NaN" waere fuer JEDE Karte falsch, es
     // wuerde also gar kein Upload erscheinen. Deshalb hart auf
     // mindestens 1 klemmen.
     const treffer = String(checked.value || '').match(/\d+/);
     const zahl = treffer ? parseInt(treffer[0], 10) : 1;
     count = Number.isFinite(zahl) && zahl > 0 ? zahl : 1;
  }
  document.querySelectorAll('.js-pet-card').forEach((card, idx) => { 
     card.style.display = (idx < count) ? 'flex' : 'none'; 
  });
  validatePanel();
};

const ensureDefaultSelection = (targetPanel = null, forceFirst = false) => {
  const pList = targetPanel ? [targetPanel] : panels;
  pList.forEach(p => {
    if (p.dataset.type === 'page-upsell') return; 
    const visibleRadios = [...p.querySelectorAll('input[type="radio"]')].filter(i => {
       const card = i.closest('.paws-card, .paws-swatch-item, .js-size-card, .paws-font-chip');
       return card ? (card.style.display !== 'none' && card.offsetParent !== null) : true;
    });
    if (visibleRadios.length > 0 && (forceFirst || !visibleRadios.some(i => i.checked))) {
      visibleRadios[0].checked = true;
      visibleRadios[0].dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
};

const updateUpsellGrid = (count) => {
  const grid = document.querySelector('.js-upsell-page-container');
  if (!grid) return;
  if (window.innerWidth > 767) {
     grid.style.gridTemplateColumns = `repeat(${count > 4 ? 4 : count}, 1fr)`;
  } else {
     grid.style.gridTemplateColumns = '1fr';
  }
};

// Wildcard-Eintraege koennen per "excluded_variants" fuer einzelne Hauptprodukte abbedungen werden (z.B. teurerer Ersatz-Upsell nur fuer ein Produkt).
const upsellGiltFuerVariante = (m, curId) => {
  if (!m) return false;
  if (Array.isArray(m.excluded_variants) && m.excluded_variants.map(String).includes(String(curId))) return false;
  if (m.variants === "*") return true;
  return Array.isArray(m.variants) && m.variants.map(String).includes(String(curId));
};

const renderPageUpsells = () => {
  const c = document.querySelector('.js-upsell-page-container'); if (!c) return 0;
  c.innerHTML = ''; 
  // V177: USE GLOBAL ID
  const curId = currentMainVariantId;
  
  c.insertAdjacentHTML('beforeend', `<label class="paws-card is-neutral"><input type="radio" name="page_upsell_choice" value="none" class="js-page-upsell-radio"><div class="paws-card-inner"><span class="paws-upsell-page-title" style="margin:auto;">${pawsText('upsell_no_upgrade')}</span></div></label>`);
  const itemsToSort = [];
  for (const h in upsellMapping) {
    if(h === '__bundles') continue;
    const m = upsellMapping[h]; const prod = activeUpsellProducts[h];
    if (m && prod && m.configurator_page_upsell && upsellGiltFuerVariante(m, curId)) {
      itemsToSort.push({ handle: h, mapping: m, product: prod });
    }
  }
  itemsToSort.sort((a, b) => (a.mapping.configurator_page_upsell_ranking || 999) - (b.mapping.configurator_page_upsell_ranking || 999));
  itemsToSort.forEach(item => {
    const h = item.handle; const m = item.mapping; const prod = item.product;
    const isChecked = selectedUpsells.has(h) ? 'checked' : '';
    const badgeHtml = m.configurator_page_upsell_text ? `<div class="paws-badge">${m.configurator_page_upsell_text}</div>` : '';
    const compHtml = prod.compare_at_price ? `<span class="paws-upsell-page-compare">${(prod.compare_at_price / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</span>` : '';
    c.insertAdjacentHTML('beforeend', `<label class="paws-card">${badgeHtml}<input type="radio" name="page_upsell_choice" value="${h}" data-key="${h}" class="js-page-upsell-radio" ${isChecked}><div class="paws-card-inner"><img src="${prod.featured_image}" class="paws-upsell-page-img"><span class="paws-upsell-page-title">${prod.title}</span><div class="paws-upsell-page-prices">+ ${(prod.price / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}${compHtml}</div></div></label>`);
  });
  document.querySelectorAll('.js-page-upsell-radio').forEach(r => r.addEventListener('change', (e) => {
    for (const h in upsellMapping) if (upsellMapping[h] && upsellMapping[h].configurator_page_upsell) selectedUpsells.delete(h);
    if (e.target.value !== 'none') selectedUpsells.add(e.target.dataset.key);
    updatePrice(); validatePanel();
    const gewaehlt = e.target.value !== 'none';
    const prod = gewaehlt ? activeUpsellProducts[e.target.dataset.key] : null;
    track('configurator_upsell', Object.assign(schrittInfo(), {
      upsell_placement: 'schritt',
      upsell_action: gewaehlt ? 'gewaehlt' : 'abgelehnt',
      upsell_handle: gewaehlt ? e.target.dataset.key : null,
      upsell_value: prod ? prod.price / 100 : 0
    }));
  }));
  updateUpsellGrid(itemsToSort.length + 1);
  
  // V183: IF 0 ITEMS, RETURN 0 SO RENDER KNOWS TO SKIP
  return itemsToSort.length;
};

const geldFormat = (eur) => eur.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

// Das Emoji steckt im uebersetzten Text - erst als eigenes Element bekommt es Abstand.
const lieferzeitTrennen = () => {
  const zeile = document.querySelector('.paws-checkout-box .paws-delivery');
  if (!zeile || zeile.querySelector('.paws-delivery__icon')) return;
  const roh = zeile.textContent.trim();
  let treffer = null;
  try {
    treffer = roh.match(/^(\p{Extended_Pictographic}[\p{Extended_Pictographic}\uFE0F\u200D]*)\s*([\s\S]+)$/u);
  } catch (e) {
    return;
  }
  if (!treffer) return;
  zeile.textContent = '';
  const icon = document.createElement('span');
  icon.className = 'paws-delivery__icon';
  icon.setAttribute('aria-hidden', 'true');
  icon.textContent = treffer[1];
  zeile.appendChild(icon);
  zeile.appendChild(document.createTextNode(treffer[2]));
};
const REVIEW_PRODUKT = CFG.produktTitel;
const REVIEW_KEEP_CASE = CFG.keepVariantCase;
const HAKEN_PFAD = 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z';
const CHEVRON_PFAD = 'M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z';
// Offen als Standard: bei personalisierten Artikeln ist die Kontrolle der Eingaben Teil des Vertrauens.
let reviewOffen = true;
let addonsAlleZeigen = false;
const ADDONS_SICHTBAR = 3;

const svgSymbol = (pfad) => {
  const raum = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(raum, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('aria-hidden', 'true');
  const pfadEl = document.createElementNS(raum, 'path');
  pfadEl.setAttribute('d', pfad);
  svg.appendChild(pfadEl);
  return svg;
};

// Der Name im Feld ("properties[Grundfarbe]") ist zugleich das, was spaeter im
// Warenkorb steht - als Beschriftung also naeher an der Bestellung als der Schritttitel.
const reviewLabel = (name) => {
  const treffer = String(name || '').match(/^(?:properties|options)\[(.+)\]$/);
  return treffer ? treffer[1].trim() : '';
};

const reviewPosten = () => {
  const liste = [];
  const gesehen = new Set();
  document.querySelectorAll('#paws-configurator-wrapper [name^="properties["], #paws-configurator-wrapper [name^="options["]').forEach(feld => {
    const label = reviewLabel(feld.name);
    if (!label || label.indexOf('__paws') === 0) return;
    if (/^bild\d+$/i.test(label) || /^Name \d+$/i.test(label) || /^sku$/i.test(label)) return;
    if (feld.disabled || feld.closest('.js-text-line[hidden]')) return;
    let wert;
    if (feld.type === 'radio' || feld.type === 'checkbox') {
      if (!feld.checked) return;
      // Auf der Kachel steht die schoenere Schreibweise ("Poster" statt "poster").
      const kachel = feld.closest('label, .paws-swatch-item, .paws-background-item');
      const sichtbar = kachel && kachel.querySelector('.paws-card-inner span, .paws-swatch-item-name');
      wert = sichtbar ? sichtbar.textContent.trim() : feld.value;
      if (!sichtbar && !REVIEW_KEEP_CASE && feld.name.indexOf('options[') === 0) {
        wert = wert.charAt(0).toUpperCase() + wert.slice(1);
      }
    } else if (feld.type === 'file') {
      return;
    } else {
      wert = feld.value;
    }
    wert = String(wert || '').trim();
    if (!wert || gesehen.has(label)) return;
    gesehen.add(label);
    const namen = (window.PAWS_TEXTE && window.PAWS_TEXTE.review_labels) || {};
    liste.push({ label: namen[label] || label, wert });
  });
  return liste;
};

const reviewFotos = () => {
  return [...document.querySelectorAll('.js-pet-card')]
    .filter(karte => karte.style.display !== 'none')
    .map((karte, i) => {
      const box = karte.querySelector('.js-preview-box');
      const feld = karte.querySelector('.js-file-in');
      const name = karte.querySelector('.js-pet-name-input');
      return {
        nr: i + 1,
        bild: box ? box.style.backgroundImage : '',
        hatDatei: !!(feld && feld.files && feld.files.length),
        name: name ? name.value.trim() : ''
      };
    });
};

const renderReview = () => {
  const box = document.querySelector('.js-review');
  if (!box) return;
  box.textContent = '';

  const fotos = reviewFotos();
  const posten = reviewPosten();
  // Ohne Foto gibt es keine Kachel - der Name soll trotzdem sichtbar bleiben.
  const namensZeilen = fotos.filter(foto => !foto.bild && !foto.hatDatei && foto.name).map(foto => ({
    label: fotos.length > 1 ? pawsText('review_pet_name_n', { nr: foto.nr }) : pawsText('review_pet_name'),
    wert: foto.name
  }));
  posten.unshift(...namensZeilen);

  const kopf = document.createElement('button');
  kopf.type = 'button';
  kopf.className = 'paws-review__title js-review-toggle' + (reviewOffen ? ' is-open' : '');
  kopf.setAttribute('aria-expanded', reviewOffen ? 'true' : 'false');
  kopf.setAttribute('aria-label', pawsText(reviewOffen ? 'review_close' : 'review_open'));
  kopf.appendChild(svgSymbol(HAKEN_PFAD));
  const kopfText = document.createElement('span');
  kopfText.className = 'paws-review__titletext';
  kopfText.appendChild(document.createTextNode(pawsText('review_title')));
  if (!reviewOffen && posten.length) {
    const kurz = document.createElement('span');
    kurz.className = 'paws-review__short';
    kurz.textContent = posten.map(eintrag => eintrag.wert).join(' · ');
    kopfText.appendChild(kurz);
  }
  kopf.appendChild(kopfText);
  const pfeil = svgSymbol(CHEVRON_PFAD);
  pfeil.setAttribute('class', 'paws-review__chevron');
  kopf.appendChild(pfeil);
  kopf.addEventListener('click', () => { reviewOffen = !reviewOffen; renderReview(); });
  box.appendChild(kopf);

  const mitBild = fotos.filter(foto => foto.bild || foto.hatDatei);
  if (mitBild.length) {
    const reihe = document.createElement('div');
    reihe.className = 'paws-review__photos';
    mitBild.forEach(foto => {
      const kachel = document.createElement('figure');
      kachel.className = 'paws-review__photo';
      const vorschau = document.createElement('div');
      vorschau.className = 'paws-review__thumb';
      if (foto.bild) {
        vorschau.style.backgroundImage = foto.bild;
      } else {
        // HEIC und aehnliche Formate zeigt kein Browser an, hochgeladen sind sie trotzdem.
        vorschau.classList.add('is-ok');
        vorschau.appendChild(svgSymbol(HAKEN_PFAD));
      }
      const text = document.createElement('figcaption');
      text.className = 'paws-review__caption';
      text.textContent = foto.name || pawsText('review_photo_ok', { nr: foto.nr });
      kachel.appendChild(vorschau);
      kachel.appendChild(text);
      reihe.appendChild(kachel);
    });
    box.appendChild(reihe);
  }

  if (!reviewOffen) return;

  if (posten.length) {
    const liste = document.createElement('div');
    liste.className = 'paws-review__list';
    posten.forEach(eintrag => {
      const zeile = document.createElement('div');
      zeile.className = 'paws-review__row';
      const label = document.createElement('span');
      label.className = 'paws-review__label';
      label.textContent = eintrag.label;
      const wert = document.createElement('span');
      wert.className = 'paws-review__value';
      wert.textContent = eintrag.wert;
      zeile.appendChild(label);
      zeile.appendChild(wert);
      liste.appendChild(zeile);
    });
    box.appendChild(liste);
  }

  let zusatz = 0;
  const zeilen = [];
  document.querySelectorAll('.js-upsell-checkbox:checked, .js-page-upsell-radio:checked').forEach(feld => {
    const up = activeUpsellProducts[feld.dataset.key];
    if (!up) return;
    zusatz += up.price / 100;
    zeilen.push({ name: up.title, preis: up.price / 100, zusatz: true, feld });
  });
  zeilen.unshift({ name: REVIEW_PRODUKT, preis: Math.max(0, currentPriceEur - zusatz), zusatz: false });

  const summe = document.createElement('div');
  summe.className = 'paws-review__sum';
  zeilen.forEach(eintrag => {
    const zeile = document.createElement('div');
    zeile.className = 'paws-review__sumrow' + (eintrag.zusatz ? ' is-add' : '');
    const name = document.createElement('span');
    name.className = 'paws-review__sumname';
    name.textContent = (eintrag.zusatz ? '+ ' : '') + eintrag.name;
    const preis = document.createElement('span');
    preis.className = 'paws-review__sumprice';
    preis.textContent = geldFormat(eintrag.preis);
    zeile.appendChild(name);
    zeile.appendChild(preis);
    if (eintrag.zusatz && eintrag.feld && eintrag.feld.type === 'checkbox') {
      const weg = document.createElement('button');
      weg.type = 'button';
      weg.className = 'paws-review__remove';
      weg.textContent = '\u2715';
      weg.setAttribute('aria-label', pawsText('review_remove', { titel: eintrag.name }));
      weg.title = weg.getAttribute('aria-label');
      weg.addEventListener('click', () => {
        // Ueber das Feld selbst, damit die bestehende Upsell-Logik samt Tracking greift.
        eintrag.feld.checked = false;
        eintrag.feld.dispatchEvent(new Event('change', { bubbles: true }));
      });
      zeile.appendChild(weg);
    }
    summe.appendChild(zeile);
  });
  box.appendChild(summe);
};

const renderUpsellsSummary = () => {
  const c = document.querySelector('.js-upsell-container'); if (!c) return;
  c.innerHTML = ''; 
  // V177: USE GLOBAL ID
  const curId = currentMainVariantId;
  
  let visibleSingles = [];
  Object.keys(activeUpsellProducts).forEach(h => {
    const m = upsellMapping[h]; const prod = activeUpsellProducts[h];
    if (m && prod && m.configurator_summary_upsell && upsellGiltFuerVariante(m, curId)) {
       visibleSingles.push({ 
          handle: h, 
          product: prod,
          configId: m.product_id 
       });
    }
  });

  let eligibleBundle = null;
  const bundleConfig = upsellMapping['__bundles'];
  if(bundleConfig) {
     const visibleIds = visibleSingles.map(s => String(s.configId)).sort().join(',');
     
     for(const b of bundleConfig) {
        const triggerIds = (b.trigger_product_ids || []).map(String).sort().join(',');
        if (triggerIds === visibleIds && triggerIds.length > 0) {
           eligibleBundle = b;
           break;
        }
     }
  }

  // Prozent wirkt bei kleinen Betraegen staerker als der Euro-Wert.
  const sparBadge = (prod) => {
    if (!(prod.compare_at_price > prod.price)) return '';
    const pct = Math.round((prod.compare_at_price - prod.price) / prod.compare_at_price * 100);
    return `<span class="paws-upsell-save">${pawsText('upsell_save', { prozent: pct, betrag: geldFormat((prod.compare_at_price - prod.price) / 100) })}</span>`;
  };
  // Kurzer Beleg, dass andere das auch nehmen - Text kommt aus upsell_v1.json ("social_proof").
  const sozialZeile = (text) => {
    const wert = String(text || pawsText('upsell_social') || '').trim();
    return wert ? `<span class="paws-upsell-social">${wert}</span>` : '';
  };

  // Das Spar-Set steht bewusst zuoberst: es ist das beste Angebot der Liste.
  if(eligibleBundle && eligibleBundle.bundle_product_handle && activeUpsellProducts[eligibleBundle.bundle_product_handle]) {
     const h = eligibleBundle.bundle_product_handle;
     const prod = activeUpsellProducts[h];
     const isChecked = selectedUpsells.has(h) ? 'checked' : '';
     const cHtml = prod.compare_at_price ? `<span class="paws-upsell-compare">${(prod.compare_at_price / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</span>` : '';
     const badge = eligibleBundle.highlight_text ? `<span class="paws-upsell-badge">${eligibleBundle.highlight_text}</span>` : '';
     const triggerStr = eligibleBundle.trigger_product_ids.join(',');

     c.insertAdjacentHTML('beforeend', `<label class="paws-upsell-item is-bundle">${badge}<input type="checkbox" class="js-upsell-checkbox" data-key="${h}" data-type="bundle" data-triggers="${triggerStr}" data-variant-id="${prod.variants[0].id}" ${isChecked}><div class="paws-upsell-info"><span class="paws-upsell-title">${prod.title}</span><div class="paws-upsell-price-row"><span class="paws-upsell-current">+ ${(prod.price / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</span>${cHtml}${sparBadge(prod)}</div>${sozialZeile(eligibleBundle.social_proof)}</div><img src="${prod.featured_image}" class="paws-upsell-img"></label>`);
  }

  visibleSingles.forEach(s => {
     const h = s.handle; const prod = s.product;
     const isChecked = selectedUpsells.has(h) ? 'checked' : '';
     const cHtml = prod.compare_at_price ? `<span class="paws-upsell-compare">${(prod.compare_at_price / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</span>` : '';
     c.insertAdjacentHTML('beforeend', `<label class="paws-upsell-item js-single-item" data-product-id="${s.configId}"><input type="checkbox" class="js-upsell-checkbox" data-key="${h}" data-type="single" data-variant-id="${prod.variants[0].id}" ${isChecked}><div class="paws-upsell-info"><span class="paws-upsell-title">${prod.title}</span><div class="paws-upsell-price-row"><span class="paws-upsell-current">+ ${(prod.price / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</span>${cHtml}${sparBadge(prod)}</div>${sozialZeile((upsellMapping[h] || {}).social_proof)}</div><img src="${prod.featured_image}" class="paws-upsell-img"></label>`);
  });

  // Jedes ungesehene Extra kostet Bestellwert. Eingeklappt wird deshalb
  // erst, wenn die Liste wirklich lang wird - fuer ein einzelnes
  // verstecktes Angebot lohnt der Aufklappklick nicht.
  let versteckt = 0;
  const items = [...c.querySelectorAll('.paws-upsell-item')];
  if (!addonsAlleZeigen && items.length > ADDONS_SICHTBAR + 1) {
    let gezeigt = 0;
    items.forEach(item => {
      if (item.querySelector('input:checked') || gezeigt < ADDONS_SICHTBAR) { gezeigt++; return; }
      item.hidden = true;
      versteckt++;
    });
  }
  if (versteckt) {
    const mehr = document.createElement('button');
    mehr.type = 'button';
    mehr.className = 'paws-addons__more';
    mehr.textContent = pawsText('addons_more', { anzahl: versteckt });
    mehr.addEventListener('click', () => { addonsAlleZeigen = true; renderUpsellsSummary(); });
    c.appendChild(mehr);
  }

  const block = c.closest('.paws-addons');
  if (block) {
    const kopf = block.querySelector('.js-addons-head');
    if (kopf && !kopf.childElementCount) {
      const titel = document.createElement('span');
      titel.className = 'paws-addons__title';
      titel.textContent = pawsText('addons_title');
      const unter = document.createElement('span');
      unter.className = 'paws-addons__sub';
      unter.textContent = pawsText('addons_subtitle');
      kopf.appendChild(titel);
      kopf.appendChild(unter);
    }
    block.hidden = c.children.length === 0;
  }

  document.querySelectorAll('.js-upsell-checkbox').forEach(cb => cb.addEventListener('change', (e) => { 
     const me = e.target;
     const myType = me.dataset.type;
     const container = document.querySelector('.js-upsell-container');

     if (me.checked) {
        selectedUpsells.add(me.dataset.key);
        if (myType === 'bundle') {
           const triggers = me.dataset.triggers.split(',').map(Number);
           container.querySelectorAll('.js-upsell-checkbox[data-type="single"]').forEach(scb => {
              const sPid = Number(scb.closest('.js-single-item').dataset.productId);
              if(triggers.includes(sPid)) {
                 scb.checked = false;
                 selectedUpsells.delete(scb.dataset.key);
              }
           });
        } else if (myType === 'single') {
           const bundleCb = container.querySelector('.js-upsell-checkbox[data-type="bundle"]');
           if (bundleCb) {
              bundleCb.checked = false;
              selectedUpsells.delete(bundleCb.dataset.key);
           }
        }
     } else {
        selectedUpsells.delete(me.dataset.key);
     }
     // Die Auswahlliste oberhalb waechst um eine Zeile, wodurch die eben
     // angeklickte Karte nach unten wegrutscht. Der Versatz wird durch
     // Mitscrollen ausgeglichen, damit sie unter dem Finger stehen bleibt.
     const karte = me.closest('.paws-upsell-item');
     const vorher = karte ? karte.getBoundingClientRect().top : 0;
     updatePrice();
     if (karte) {
       const versatz = karte.getBoundingClientRect().top - vorher;
       if (Math.abs(versatz) > 1 && Math.abs(versatz) < 400) window.scrollBy({ top: versatz, behavior: 'instant' });
     }
     const prodUp = activeUpsellProducts[me.dataset.key];
     track('configurator_upsell', Object.assign(schrittInfo(), {
       upsell_placement: 'zusammenfassung',
       upsell_action: me.checked ? 'gewaehlt' : 'entfernt',
       upsell_handle: me.dataset.key,
       upsell_type: myType,
       upsell_value: prodUp ? prodUp.price / 100 : 0
     }));
  }));
};

// Schritt-Kennzahlen fuer das Tracking; step_total bleibt bewusst stabil,
// damit sich Produkte mit unterschiedlich vielen Schritten vergleichen lassen.
const schrittInfo = (idx = currentIdx) => {
  const p = panels[idx];
  if (!p) return {};
  const titel = p.querySelector('.paws-title');
  return {
    step_index: idx + 1,
    step_total: panels.length,
    step_id: p.dataset.type,
    step_name: (titel ? titel.textContent : p.dataset.type).replace(/\s+/g, ' ').trim().slice(0, 80)
  };
};
let schrittSeit = Date.now();
let letzterSichtIdx = -1;
const sekundenImSchritt = () => Math.round((Date.now() - schrittSeit) / 100) / 10;

// Der echte Kaufbutton steht am Ende einer langen Seite - diese Leiste holt ihn nach vorn.
const stickyLeiste = document.querySelector('.js-sticky-checkout');
const stickyBtn = stickyLeiste ? stickyLeiste.querySelector('.js-sticky-atc') : null;
const echterAtc = document.querySelector('.paws-panel[data-type="summary"] .js-custom-atc-btn');
let atcImBlick = false;
// Wird weiter unten belegt. Vorab deklariert, weil stickyPruefen() den
// Knopfzustand mitfuehren muss: bei aktivem bypass_validation aendert
// sich am echten Kaufknopf nichts, wenn ein Foto dazukommt - der
// MutationObserver allein wuerde den Wechsel also verschlafen.
let spiegeln = () => {};
// Aufgabe 3: In Variante B haengt die Leiste nicht mehr am Kaufbutton,
// sondern am Kaufblock als Ganzem - Preiskarte, Kaufknopf und
// Warenkorb-Link. Solange dieser Block im Fenster steht, waere die
// Leiste eine zweite Kaufaufforderung ueber der ersten. Darunter
// (Vertrauenspunkte, Zahlarten) faehrt sie wieder ein.
const kaufBlockImBlick = () => {
  const summary = document.querySelector('.paws-panel[data-type="summary"]');
  if (!summary) return atcImBlick;
  const oben = summary.querySelector('.paws-checkout-box');
  const unten = summary.querySelector('.js-cart-only') || summary.querySelector('.paws-footer') || echterAtc;
  if (!oben || !unten) return atcImBlick;
  const vh = window.innerHeight || document.documentElement.clientHeight || 0;
  if (!vh) return atcImBlick;
  const o = oben.getBoundingClientRect().top;
  const u = unten.getBoundingClientRect().bottom;
  if (!Number.isFinite(o) || !Number.isFinite(u)) return atcImBlick;
  // Die Leiste selbst deckt den unteren Rand ab - erst wenn der Block
  // oberhalb ihrer Oberkante beginnt, ist er wirklich zu sehen.
  const leistenHoehe = stickyLeiste ? stickyLeiste.offsetHeight : 0;
  return u > 0 && o < (vh - leistenHoehe);
};
const stickyPruefen = () => {
  if (!stickyLeiste || !echterAtc) return;
  // Variante A: die Leiste gehoert zur Zusammenfassung.
  // Variante B: sie begleitet den ganzen Konfigurator - sie faehrt ein,
  // sobald der erste Schritt den unteren Fensterrand erreicht hat, und
  // weicht nur fuer den Kaufblock selbst.
  let an;
  if (einseitig) {
    const vh = window.innerHeight || document.documentElement.clientHeight || 0;
    const ersterSchritt = panels.find(p => p.dataset.skipped !== 'true');
    const begonnen = !!vh && !!ersterSchritt && ersterSchritt.getBoundingClientRect().top <= vh;
    an = begonnen && !kaufBlockImBlick();
  } else {
    an = (!!panels[currentIdx] && panels[currentIdx].dataset.type === 'summary' && !atcImBlick);
  }
  if (stickyLeiste.classList.contains('is-visible') !== an) {
    stickyLeiste.classList.toggle('is-visible', an);
    stickyLeiste.setAttribute('aria-hidden', an ? 'false' : 'true');
    document.body.classList.toggle('paws-sticky-checkout-an', an);
  }
  spiegeln();
};
// ---- C1: progressive Beschriftung der Kaufleiste (nur Variante B) ----
// Solange ein Schritt noch offen ist, kauft der Knopf nicht, sondern
// bringt den Kunden dorthin. Ein Schritt gilt als offen, wenn eine
// sichtbare Pflichtangabe fehlt. Die Beschriftungen stehen im
// globalen Textbund (assets/paws-texte.js).
const STICKY_GRUND_TEXT = { foto: 'sticky_guide_upload', text: 'sticky_guide_text', auswahl: 'sticky_guide_select' };
const sichtbarInPanel = (el) => {
  const k = el.closest('.js-pet-card, .js-brand-models-wrapper, .js-text-line');
  if (k && (k.style.display === 'none' || k.hasAttribute('hidden'))) return false;
  return true;
};
const panelGrund = (p) => {
  if (!p || p.dataset.skipped === 'true' || p.dataset.type === 'summary') return null;
  if ([...p.querySelectorAll('input[type="file"]')].some(f => !f.disabled && sichtbarInPanel(f) && f.files.length === 0)) return 'foto';
  if ([...p.querySelectorAll('.js-paws-text-input[data-required="true"]')].some(el => sichtbarInPanel(el) && el.value.trim() === '')) return 'text';
  if ([...p.querySelectorAll('select:not([disabled])')].some(s => sichtbarInPanel(s) && s.value === '')) return 'auswahl';
  return null;
};
// Merkt sich, wohin schon einmal gefuehrt wurde. Ohne das entstuende
// eine Sackgasse: bei aktivem bypass_validation ist ein fehlender
// Upload erlaubt, der Knopf wuerde aber nie in den Kaufzustand
// wechseln und der Kunde koennte aus der Leiste nie bestellen.
let gefuehrtZu = -1;
const offenerSchritt = () => {
  if (!einseitig) return null;
  const i = panels.findIndex(p => panelGrund(p) !== null);
  if (i === -1 || i === gefuehrtZu) return null;
  return { idx: i, grund: panelGrund(panels[i]) };
};

// Nach einem Fuehrungs-Klick kann der Schritt "Zusatzangebote" noch
// nachtraeglich erscheinen: loadUpsells() holt seine Daten asynchron
// und der Schritt bleibt bis dahin ausgeblendet. Taucht er oberhalb des
// Sprungziels auf, schiebt er es um seine ganze Hoehe nach unten und
// der Kunde steht am falschen Schritt. Deshalb wird das Ziel kurz
// nachgefuehrt - eng begrenzt durch Zeitfenster, Korrekturzahl und die
// erste eigene Scrollgeste, damit daraus nie ein Regelkreis wird.
const ZIEL_ABSTAND = 90; // deckungsgleich mit scroll-margin-top im CSS
let haltenZiel = null, haltenBis = 0, haltenRest = 0;
const haltenAus = () => { haltenZiel = null; };
['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(e => window.addEventListener(e, haltenAus, { passive: true }));
const zielFesthalten = (el) => { haltenZiel = el; haltenBis = Date.now() + 5000; haltenRest = 5; };
const zielNachfuehren = () => {
  if (!haltenZiel) return;
  if (Date.now() > haltenBis || haltenRest <= 0) { haltenZiel = null; return; }
  const r = haltenZiel.getBoundingClientRect();
  if (!r.height) return;
  const abw = r.top - ZIEL_ABSTAND;
  // Totband gegen Subpixel-Zittern - ohne das schriebe jede Messung.
  if (Math.abs(abw) < 4) return;
  haltenRest--;
  window.scrollTo({ top: Math.max(0, window.scrollY + abw), behavior: 'auto' });
};

if (stickyLeiste && stickyBtn && echterAtc) {
  // position: fixed traegt nur, wenn kein Vorfahre transformiert ist.
  document.body.appendChild(stickyLeiste);
  stickyBtn.addEventListener('click', () => {
    if (stickyBtn.disabled) return;
    const ziel = parseInt(stickyBtn.dataset.ziel || '', 10);
    if (Number.isFinite(ziel) && panels[ziel]) {
      // Aus einem Klick heraus zu scrollen ist unbedenklich - anders
      // als aus einem scroll-Handler, wo es auf iOS rueckkoppelt.
      gefuehrtZu = ziel;
      zielFesthalten(panels[ziel]);
      panels[ziel].scrollIntoView({ behavior: 'smooth', block: 'start' });
      track('configurator_sticky_cta', Object.assign(schrittInfo(ziel), { sticky_cta_state: 'fuehren' }));
      spiegeln();
      return;
    }
    track('configurator_sticky_cta', Object.assign(schrittInfo(), { sticky_cta_state: 'kaufen' }));
    echterAtc.click();
  });

  spiegeln = () => {
    const offen = offenerSchritt();
    const fuehren = !!offen;
    // Der Fuehrungszustand nennt die fehlende Angabe beim Namen -
    // "Weiter: Foto hochladen" sagt mehr als ein generisches "Weiter".
    const label = fuehren ? pawsText(STICKY_GRUND_TEXT[offen.grund]) : echterAtc.textContent;
    const gesperrt = fuehren ? false : echterAtc.disabled;
    const beschaeftigt = !fuehren && echterAtc.classList.contains('is-busy');
    // Erst pruefen, dann schreiben - der MutationObserver auf dem
    // echten Kaufknopf feuert sonst bei jedem Rendervorgang Layouts.
    if (stickyBtn.textContent !== label) stickyBtn.textContent = label;
    if (stickyBtn.disabled !== gesperrt) stickyBtn.disabled = gesperrt;
    if (stickyBtn.classList.contains('is-busy') !== beschaeftigt) stickyBtn.classList.toggle('is-busy', beschaeftigt);
    if (stickyBtn.classList.contains('is-guide') !== fuehren) stickyBtn.classList.toggle('is-guide', fuehren);
    const zielAttr = fuehren ? String(offen.idx) : '';
    if (stickyBtn.dataset.ziel !== zielAttr) stickyBtn.dataset.ziel = zielAttr;
  };
  spiegeln();
  new MutationObserver(spiegeln).observe(echterAtc, { attributes: true, childList: true, characterData: true, subtree: true });

  if ('IntersectionObserver' in window) {
    // Sobald der echte Kaufbutton auch nur einen Pixel im Blickfeld hat,
    // hat die Leiste nichts mehr zu tun.
    new IntersectionObserver((eintraege) => {
      eintraege.forEach(e => { atcImBlick = e.isIntersecting; });
      stickyPruefen();
    }, { threshold: 0 }).observe(echterAtc);
  }

  const atcFehler = document.querySelector('.paws-panel[data-type="summary"] .js-atc-error');
  if (atcFehler) {
    // Aus der Leiste heraus gekauft, laege die Fehlermeldung sonst weit ausserhalb des Blickfelds.
    new MutationObserver(() => {
      if (atcFehler.style.display !== 'none' && stickyLeiste.classList.contains('is-visible')) {
        atcFehler.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }).observe(atcFehler, { attributes: true, attributeFilter: ['style'] });
  }
}

/* ==================================================================
   VARIANTE B (A/B-Test): einseitige Darstellung
   ------------------------------------------------------------------
   Es wird KEIN zweiter Konfigurator gebaut. Genutzt werden dasselbe
   Markup, dieselben Felder und dieselben Rechenwege - nur werden alle
   Schritte gleichzeitig gezeigt statt nacheinander. Damit ist der an
   /cart/add.js gesendete Payload bauartbedingt mit Variante A gleich.
   ================================================================== */

// configurator_step_view hat in Variante B keinen Schrittwechsel mehr,
// an dem es haengen koennte. Massgeblich ist - wie beim T&P-Konfigurator -
// das Erscheinen im Blickfeld, mit derselben Definition (5 % bis 75 %
// der Fensterhoehe) wie in assets/paws-insights.js.
const sichtGemeldet = Object.create(null);
const schrittSichtPruefen = () => {
  if (!einseitig) return;
  const vh = window.innerHeight || document.documentElement.clientHeight || 0;
  if (!vh) return;
  const oben = vh * 0.05;
  const unten = vh * 0.75;
  panels.forEach((p, i) => {
    if (sichtGemeldet[i] || p.dataset.skipped === 'true') return;
    const r = p.getBoundingClientRect();
    if (!r.height) return;
    if (r.top >= unten || r.bottom <= oben) return;
    sichtGemeldet[i] = true;
    // Damit seconds_on_step dieselbe Bedeutung behaelt wie in Variante A:
    // die Zeit seit dem zuletzt erreichten Schritt.
    schrittSeit = Date.now();
    track('configurator_step_view', Object.assign(schrittInfo(i), {
      direction: 'scroll',
      next_blocked: !!(customAtcBtn && customAtcBtn.disabled)
    }));
  });
};

let sichtTimer = null;
const sichtAnstossen = () => {
  if (sichtTimer) return;
  sichtTimer = setTimeout(() => {
    sichtTimer = null;
    // Bewusst kein window.scrollTo aus einem scroll-Handler heraus -
    // das erzeugt auf iOS Rueckkopplungen.
    try { schrittSichtPruefen(); } catch (e) {}
    try { stickyPruefen(); } catch (e) {}
  }, 120);
};

// Alle Schritte sind gleichzeitig sichtbar, also muessen die Teil-Renderer
// aller Schritte laufen - nicht nur der des "aktuellen".
let einseitigLaeuft = false;
const renderEinseitig = (mitVorauswahl = false) => {
  // Re-Entry-Schutz: ensureDefaultSelection loest change-Ereignisse aus,
  // die ueber den globalen Listener wieder hier landen wuerden.
  if (einseitigLaeuft) return;
  einseitigLaeuft = true;
  try {
    // Reihenfolge ist entscheidend: erst Vorauswahl und Preis, denn
    // renderPageUpsells() filtert die Angebote ueber
    // currentMainVariantId - das setzt erst updatePrice(). Andersherum
    // liefe der Filter auf einem veralteten Wert und der Schritt
    // bliebe leer bzw. zeigte fremde Angebote.
    if (mitVorauswahl) ensureDefaultSelection();
    updatePrice();
    const upsellPanel = panels.find(p => p.dataset.type === 'page-upsell');
    if (upsellPanel) {
      // Ohne passende Angebote faellt der Schritt komplett weg (CSS),
      // sonst entstuende eine leere Nummer in der Zaehlung.
      upsellPanel.dataset.skipped = renderPageUpsells() === 0 ? 'true' : 'false';
    }
    if (panels.some(p => p.dataset.type === 'phones')) {
      const chk = document.querySelector('.js-brand-trigger:checked');
      if (chk) document.querySelectorAll('.js-brand-models-wrapper').forEach(w => {
        const m = w.dataset.brandId === chk.value;
        w.style.display = m ? 'block' : 'none';
        const sel = w.querySelector('select');
        if (sel) sel.disabled = !m;
      });
    }
    if (panels.some(p => p.dataset.type === 'personalization')) updatePetFields();
    if (panels.some(p => p.dataset.type === 'summary')) renderUpsellsSummary();
    validatePanel();
    stickyPruefen();
  } finally {
    einseitigLaeuft = false;
  }
  schrittSichtPruefen();
  // Genau hier taucht der Zusatzangebot-Schritt nachtraeglich auf.
  // Ein Frame spaeter steht die neue Hoehe fest.
  requestAnimationFrame(zielNachfuehren);
};

if (einseitig) {
  window.addEventListener('scroll', sichtAnstossen, { passive: true });
  window.addEventListener('resize', sichtAnstossen, { passive: true });
}

const render = (scroll = false, dir = 1) => {
  // Variante B blaettert nicht - dort steht alles gleichzeitig da.
  if (einseitig) { renderEinseitig(true); return; }
  if (currentIdx < 0) currentIdx = 0;
  if (currentIdx > panels.length - 1) currentIdx = panels.length - 1;
  if (!panels[currentIdx]) return;

  // V183: HANDLE UPSELL SKIPPING
  if (panels[currentIdx].dataset.type === 'page-upsell') {
    const count = renderPageUpsells();
    if (count === 0) {
       // Mark this panel as skipped so back button logic knows
       panels[currentIdx].dataset.skipped = 'true';
       // dir === 0 (Aufruf aus loadUpsells) wuerde hier endlos rekursieren.
       const step = dir === 0 ? 1 : dir;
       const nextIdx = currentIdx + step;
       if (nextIdx < 0 || nextIdx > panels.length - 1) return;
       currentIdx = nextIdx;
       render(scroll, step);
       return; 
    } else {
       panels[currentIdx].dataset.skipped = 'false';
    }
  } else {
       panels[currentIdx].dataset.skipped = 'false';
  }
  
  panels.forEach((p, i) => p.classList.toggle('active', i === currentIdx));
  
  updateWormIndicator();

  // V183: SMART BACK BUTTON LOGIC
  // Check if any previous panel is NOT skipped
  let canGoBack = false;
  for(let i = currentIdx - 1; i >= 0; i--) {
      if (panels[i].dataset.skipped !== 'true') {
          canGoBack = true;
          break;
      }
  }
  document.querySelectorAll('.js-btn-back').forEach(btn => btn.style.display = canGoBack ? 'flex' : 'none');

  if (panels[currentIdx].dataset.type === 'personalization') updatePetFields();
  if (panels[currentIdx].dataset.type === 'summary') renderUpsellsSummary();
  if (panels[currentIdx].dataset.type === 'phones') {
    const chk = document.querySelector('.js-brand-trigger:checked');
    if (chk) { document.querySelectorAll('.js-brand-models-wrapper').forEach(w => { const m = w.dataset.brandId === chk.value; w.style.display = m ? 'block' : 'none'; w.querySelector('select').disabled = !m; }); }
  }
  ensureDefaultSelection(panels[currentIdx]); updatePrice(); validatePanel();
  stickyPruefen();
  // render() laeuft beim Start mehrfach - nur echte Schrittwechsel melden.
  if (letzterSichtIdx !== currentIdx) {
    letzterSichtIdx = currentIdx;
    schrittSeit = Date.now();
    track('configurator_step_view', Object.assign(schrittInfo(), {
      direction: dir > 0 ? 'vor' : (dir < 0 ? 'zurueck' : 'start'),
      next_blocked: !!panels[currentIdx].querySelector('.js-btn-next:disabled')
    }));
  }
  if (scroll) {
    // Klebt die Vorschau oben, muss der Schritt darunter beginnen -
    // sonst verdeckt sie die obere Haelfte des Konfigurators.
    const oben = (window.pawsStickyTopOffset ? window.pawsStickyTopOffset() : 0) || 130;
    window.scrollTo({ top: master.getBoundingClientRect().top + window.pageYOffset - oben - 12, behavior: 'smooth' });
  }
};

document.querySelectorAll('.js-btn-next').forEach(b => b.addEventListener('click', () => { 
    if(!b.disabled) { 
        // V172: INLINE VALIDATION FOR PHONES (HARD CHECK)
        if (panels[currentIdx].dataset.type === 'phones') {
             const activeModel = document.querySelector('.js-final-model-input').value;
             if (!activeModel) {
                 const errBox = document.getElementById('paws-phone-error-msg');
                 if(errBox) {
                    errBox.innerText = pawsText('phone_error');
                    errBox.style.display = 'block';
                 }
                 track('configurator_blocked', Object.assign(schrittInfo(), { reason: 'kein_modell', seconds_on_step: sekundenImSchritt() }));
                 return; // BLOCK NAVIGATION
             }
        }
        track('configurator_step_next', Object.assign(schrittInfo(), { seconds_on_step: sekundenImSchritt() }));
        currentIdx++; 
        render(true, 1); 
    } 
}));

document.querySelectorAll('.js-btn-back').forEach(b => b.addEventListener('click', () => { 
    // V183: Smart Back - Find nearest non-skipped panel
    let targetIdx = currentIdx - 1;
    while(targetIdx >= 0) {
        if(panels[targetIdx].dataset.skipped !== 'true') {
            track('configurator_step_back', Object.assign(schrittInfo(), { seconds_on_step: sekundenImSchritt() }));
            currentIdx = targetIdx;
            render(true, -1);
            return;
        }
        targetIdx--;
    }
}));

// V184: UPSELL PROPERTY MARKER
const ATC_ZEITLIMIT = 20000;
const PAWS_DIREKT_ATC_PARAMETER = 'paws_direct_checkout';
const PAWS_DIREKT_ATC_URL = '/cart/add.js?' + PAWS_DIREKT_ATC_PARAMETER + '=1';

// Shopify muss den Aufruf im Hauptfenster sehen. UpCart darf nur den markierten
// Direktkauf ignorieren; der normale Warenkorb-Weg bleibt unveraendert.
const bisherigerUpcartSkip = window.upcartShouldSkipAddToCart;
window.upcartShouldSkipAddToCart = function (url) {
  try {
    const roh = (url && typeof url === 'object' && url.url) ? url.url : String(url || '');
    const adresse = new URL(roh, window.location.origin);
    const istCartAdd = /\/cart\/add(?:\.js)?$/.test(adresse.pathname);
    if (istCartAdd && adresse.searchParams.get(PAWS_DIREKT_ATC_PARAMETER) === '1') return true;
  } catch (e) {}
  return typeof bisherigerUpcartSkip === 'function'
    ? bisherigerUpcartSkip.apply(this, arguments)
    : false;
};

const atcSenden = (daten, fortschritt, still) => new Promise((fertig, abbrechen) => {
  const anfrage = new XMLHttpRequest();
  anfrage.open('POST', still ? PAWS_DIREKT_ATC_URL : '/cart/add.js');
  anfrage.timeout = ATC_ZEITLIMIT;
  // fetch kann den Upload-Fortschritt nicht melden, XMLHttpRequest schon.
  if (fortschritt && anfrage.upload) {
    anfrage.upload.onprogress = (e) => { if (e.lengthComputable && e.total) fortschritt(e.loaded / e.total); };
  }
  anfrage.onload = () => {
    const antwort = { ok: anfrage.status >= 200 && anfrage.status < 300, status: anfrage.status, text: anfrage.responseText };
    fertig(antwort);
  };
  anfrage.onerror = () => { abbrechen(new Error('Cart add network error')); };
  anfrage.ontimeout = () => {
    const fehler = new Error('Cart add timeout');
    fehler.name = 'AbortError';
    abbrechen(fehler);
  };
  anfrage.send(daten);
});

// Shopify begruendet Absagen im Antwort-JSON ("nur noch 2 Stueck", ...).
const atcGrund = (res) => {
  try {
    const daten = JSON.parse(res.text || '{}');
    return String(daten.description || daten.message || '').slice(0, 200);
  } catch (e) { return ''; }
};

const atcFehler = (art, meldung, kundentext) => {
  const err = new Error(meldung);
  err.pawsArt = art;
  err.pawsText = kundentext || '';
  return err;
};

const ATC_TEXTE = {
  timeout: 'atc_error_timeout',
  network: 'atc_error_network',
  server: 'atc_error_server'
};

const kaufAusfuehren = async (zurKasse = true) => {
  if (isCustomAtcSubmitting) return;

  // Variante B hat keinen Weiter-Knopf, an dem die Modellwahl haengen
  // koennte. Dieselbe harte Pflichtpruefung sitzt hier vor dem Kauf,
  // damit nie ein Handyhuellen-Artikel ohne Modell in den Warenkorb
  // gelangt - Variante A koennte das ebenfalls nicht erzeugen.
  if (einseitig && showPhonesActive) {
    const modellFeld = document.querySelector('.js-final-model-input');
    if (modellFeld && !modellFeld.value) {
      const errBox = document.getElementById('paws-phone-error-msg');
      if (errBox) {
        errBox.innerText = pawsText('phone_error');
        errBox.style.display = 'block';
        errBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      const phoneIdx = panels.findIndex(p => p.dataset.type === 'phones');
      track('configurator_blocked', Object.assign(schrittInfo(phoneIdx >= 0 ? phoneIdx : currentIdx), {
        reason: 'kein_modell',
        seconds_on_step: sekundenImSchritt()
      }));
      return;
    }
  }

  const mainId = currentMainVariantId;
  if (!mainId) {
    setInlineError(pawsText('atc_error_variant'));
    return;
  }

  // Zurueck aus der Kasse: unveraenderte Konfiguration liegt schon im Warenkorb.
  if (kaufGiltNoch()) {
    if (!zurKasse) {
      if (!(await warenkorbOeffnen())) window.location.assign(shopWurzel() + 'cart');
      return;
    }
    isCustomAtcSubmitting = true;
    if (customAtcBtn) {
      customAtcBtn.disabled = true;
      customAtcBtn.setAttribute('aria-busy', 'true');
      customAtcBtn.classList.add('is-busy');
      customAtcBtn.textContent = pawsText('atc_busy_checkout');
    }
    track('configurator_checkout_redirect', Object.assign(schrittInfo(), {
      upsell_count: selectedUpsells.size,
      erneut: true
    }));
    window.location.assign(shopWurzel() + 'checkout');
    return;
  }

  letzterKaufWeg = zurKasse;
  isCustomAtcSubmitting = true;
  setInlineError('');
  track('configurator_add_to_cart', Object.assign(schrittInfo(), {
    seconds_on_step: sekundenImSchritt(),
    kauf_weg: zurKasse ? 'checkout' : 'warenkorb',
    upsell_count: selectedUpsells.size,
    upsell_handles: [...selectedUpsells].join(',')
  }));

  const mitFotos = [...document.querySelectorAll('#paws-configurator-wrapper input[type="file"]')].some(f => f.files.length > 0);
  customAtcBtn.disabled = true;
  customAtcBtn.setAttribute('aria-busy', 'true');
  customAtcBtn.classList.add('is-busy');
  customAtcBtn.textContent = pawsText(mitFotos ? 'atc_busy_photos' : 'atc_busy');
  if (warenkorbLink) warenkorbLink.setAttribute('aria-disabled', 'true');
  let weiterleitung = false;

  let letzterStand = -1;
  const fortschritt = !mitFotos ? null : (anteil) => {
    const prozent = Math.max(0, Math.min(100, Math.round(anteil * 100)));
    if (prozent === letzterStand) return;
    letzterStand = prozent;
    customAtcBtn.textContent = prozent >= 100 ? pawsText('atc_busy_finish') : pawsText('atc_busy_progress', { prozent });
  };

  try {
    // Laeuft im Hintergrund noch eine Verkleinerung, lohnt sich das kurze Warten.
    await fotosAbwarten();
    const formData = new FormData();

    // 1. Add Main Product
    formData.append('items[0][id]', mainId);
    formData.append('items[0][quantity]', 1);
    // Traegt die Testvariante mit in die Bestellung - nur so laesst sich
    // spaeter je Sale sagen, welcher Konfigurator ihn erzeugt hat.
    formData.append('items[0][properties][__paws_flow]', 'custom_atc_v3_' + AB_VARIANTE.toLowerCase());
    const kaufToken = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    formData.append('items[0][properties][__paws_debug_token]', kaufToken);

    // 2. Collect Properties from Wrapper
    const inputs = document.querySelectorAll('#paws-configurator-wrapper [name^="properties["], #paws-configurator-wrapper [name^="options["]');

    inputs.forEach(input => {
      // Eine noch nicht hinzugefuegte Gravurzeile gehoert nicht in den Warenkorb.
      if (input.closest('.js-text-line[hidden]')) return;
      const value = gravurTexte.has(input) ? gravurTexte.get(input) : input.value;
      let shouldInclude = false;
      if (input.type === 'radio' || input.type === 'checkbox') {
        if (input.checked) shouldInclude = true;
      } else if (input.type === 'file') {
        if (input.files.length > 0) {
          formData.append(`items[0][${input.name}]`, fotoErsatz.get(input) || input.files[0]);
        }
        return;
      } else {
        if (value) shouldInclude = true;
      }

      if (shouldInclude) {
        formData.append(`items[0][${input.name}]`, value);
      }
    });

    // 2b. Gravur-Vorschau als Bild mitschicken
    // Nur auf Produkten mit Live-Vorschau (`custom.configurator_preview`);
    // auf allen anderen existiert die Funktion gar nicht erst. Ein Fehler
    // hier darf den Kauf niemals aufhalten - im Zweifel geht die Bestellung
    // ohne Bild raus.
    if (typeof window.pawsGravurBild === 'function') {
      try {
        // Exakt dieselbe Schreibweise wie bei den Datei-Uploads oben
        // (input.name === "properties[bild1]"), damit der Vorrang-Test greift.
        const bildSchluessel = `items[0][properties[${window.pawsGravurBildName || 'bild1'}]]`;
        // Ein echter Kunden-Upload unter demselben Namen hat immer Vorrang.
        if (!formData.has(bildSchluessel)) {
          const gravurBild = await window.pawsGravurBild();
          if (gravurBild) formData.append(bildSchluessel, gravurBild);
        }
      } catch (fehler) {
        console.warn('PAWS Konfigurator: Gravur-Vorschau konnte nicht erzeugt werden', fehler);
      }
    }

    // 3. Add Upsells
    let upIndex = 1;
    selectedUpsells.forEach(h => {
      const up = activeUpsellProducts[h];
      if (up) {
        formData.append(`items[${upIndex}][id]`, up.variants[0].id);
        formData.append(`items[${upIndex}][quantity]`, 1);
        formData.append(`items[${upIndex}][properties][__upcartUpsell]`, up.variants[0].id);
        // Unterstrich davor: Shopify blendet die Notiz in Kasse und Bestellbestaetigung aus.
        formData.append(`items[${upIndex}][properties][_configurator_add]`, 'true');
        upIndex++;
      }
    });

    // 4. Send Request
    let res;
    try {
      res = await atcSenden(formData, fortschritt, zurKasse);
    } catch (netz) {
      if (netz && netz.name === 'AbortError') throw atcFehler('timeout', 'Cart add timeout');
      // Ein einzelner Aussetzer, etwa beim Wechsel von WLAN auf Mobilfunk, darf den Kauf nicht kosten.
      await new Promise(r => setTimeout(r, 800));
      letzterStand = -1;
      try {
        res = await atcSenden(formData, fortschritt, zurKasse);
      } catch (nochmal) {
        throw atcFehler(nochmal && nochmal.name === 'AbortError' ? 'timeout' : 'network', `Cart add failed: ${nochmal && nochmal.message || nochmal}`);
      }
    }

    if (!res.ok) {
      const grund = atcGrund(res);
      throw atcFehler(
        res.status === 422 ? 'nicht_verfuegbar' : (res.status >= 500 ? 'server' : 'abgelehnt'),
        `Cart add failed (${res.status}): ${grund}`,
        grund
      );
    }

    merkeKauf(kaufToken);
    if (!zurKasse) window.dispatchEvent(new Event('cart:refresh'));
    track('configurator_add_to_cart_success', Object.assign(schrittInfo(), {
      kauf_weg: zurKasse ? 'checkout' : 'warenkorb',
      upsell_count: selectedUpsells.size
    }));

    if (zurKasse) {
      weiterleitung = true;
      customAtcBtn.textContent = pawsText('atc_busy_checkout');
      track('configurator_checkout_redirect', Object.assign(schrittInfo(), { upsell_count: selectedUpsells.size }));
      const wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      window.location.assign(wurzel + 'checkout');
    }
  } catch (err) {
    console.error('PAWS Configurator: Add-to-cart failed', err);
    const art = (err && err.pawsArt) || 'unbekannt';
    setInlineError(
      (err && err.pawsText) || pawsText(ATC_TEXTE[art] || 'atc_error_generic'),
      { erneut: true }
    );
    track('configurator_error', Object.assign(schrittInfo(), { error_type: 'add_to_cart', error_reason: art, error_message: String(err && err.message || err).slice(0, 120) }));
  } finally {
    // Waehrend die Kasse laedt, bleibt der Button bewusst im Ladezustand.
    if (!weiterleitung) {
      isCustomAtcSubmitting = false;
      customAtcBtn.disabled = false;
      customAtcBtn.removeAttribute('aria-busy');
      customAtcBtn.classList.remove('is-busy');
      if (warenkorbLink) warenkorbLink.removeAttribute('aria-disabled');
      kaufModusAnzeigen();
    }
  }
};

customAtcBtn?.addEventListener('click', () => kaufAusfuehren(true));
warenkorbLink?.addEventListener('click', () => kaufAusfuehren(false));

// Jede Aenderung an der Konfiguration macht die Warenkorb-Notiz ungueltig.
['change', 'input', 'click'].forEach(ereignis => {
  master?.addEventListener(ereignis, () => setTimeout(kaufModusAnzeigen, 0), true);
});

// Beim Zurueck aus der Kasse stellt der Browser den Ladezustand des Buttons mit wieder her.
window.addEventListener('pageshow', () => {
  isCustomAtcSubmitting = false;
  if (customAtcBtn) {
    customAtcBtn.disabled = false;
    customAtcBtn.removeAttribute('aria-busy');
    customAtcBtn.classList.remove('is-busy');
  }
  if (warenkorbLink) warenkorbLink.removeAttribute('aria-disabled');
  warenkorbAbgleichen();
});
if (document.readyState === 'complete') warenkorbAbgleichen();

// iOS meldet resize auch beim Ein- und Ausblenden der Adressleiste -
// nur echte Breitenwechsel sind fuer das Raster ueberhaupt relevant.
let letzteFensterBreite = window.innerWidth;
window.addEventListener('resize', () => {
  if (window.innerWidth === letzteFensterBreite) return;
  letzteFensterBreite = window.innerWidth;
  if (einseitig) { renderEinseitig(false); return; }
  if (panels[currentIdx] && panels[currentIdx].dataset.type === 'page-upsell') renderPageUpsells();
});

const renderPhoneOptions = (brandId) => {
   const allPhoneData = JSON.parse(document.getElementById('paws-phone-data-json').innerHTML);
   
   document.querySelectorAll('.js-brand-models-wrapper').forEach(w => {
      const isMatch = w.dataset.brandId === brandId;
      w.style.display = isMatch ? 'block' : 'none';
      
      const select = w.querySelector('select');
      select.disabled = !isMatch;
      
      if (isMatch) {
         const filteredModels = allPhoneData.filter(m => m.brand_id === brandId && m.available === true);
         filteredModels.sort((a, b) => {
            const seriesA = (a.series || 'Andere').toUpperCase();
            const seriesB = (b.series || 'Andere').toUpperCase();
            if (seriesA < seriesB) return -1;
            if (seriesA > seriesB) return 1;
            return b.year - a.year;
         });
         // V171: Added Placeholder
         let html = `<option value="" disabled selected>${pawsText('phone_placeholder')}</option>`;
         filteredModels.forEach(m => {
            html += `<option value="${m.name}" data-sku-code="${m.code}">${m.name}</option>`;
         });
         select.innerHTML = html;
      }
   });
};

// Freitext (z.B. Gravur): nur deutsches Alphabet, Ziffern und gaengige
// Satzzeichen - alles andere (Emoji, kyrillisch, ...) faellt raus.
const TEXT_INPUT_FORBIDDEN = /[^A-Za-z0-9\u00C4\u00D6\u00DC\u00E4\u00F6\u00FC\u00DF \-&()\.,:;!?'"+*#@\/]/g;
document.querySelectorAll('.js-paws-text-input, .js-paws-line-input').forEach(input => {
  const wrap = input.closest('.paws-text-input-wrapper, .paws-text-line');
  const hint = wrap ? wrap.querySelector('.js-text-input-hint') : null;
  const counter = wrap ? wrap.querySelector('.js-text-input-count') : null;
  const max = parseInt(input.getAttribute('maxlength'), 10) || 0;
  // Eigenes Muster je Zeile; ein ungueltiger Ausdruck faellt auf den Standard zurueck.
  let forbidden = TEXT_INPUT_FORBIDDEN;
  if (input.dataset.forbidden) {
    try { forbidden = new RegExp(input.dataset.forbidden, 'g'); }
    catch (err) { console.warn('PAWS Konfigurator: ungueltiges Zeichenmuster "' + input.dataset.forbidden + '" - es gilt der Standard.'); }
  }
  const syncTextInput = () => {
    const before = input.value;
    const clean = before.replace(forbidden, '');
    if (clean !== before) {
      const caret = input.selectionStart === null ? clean.length : input.selectionStart;
      const next = Math.max(0, caret - (before.length - clean.length));
      input.value = clean;
      try { input.setSelectionRange(next, next); } catch (err) {}
      if (hint) hint.textContent = input.dataset.error || '';
    } else if (hint) {
      hint.textContent = '';
    }
    if (counter && max) counter.textContent = clean.length + '/' + max;
    validatePanel();
  };
  input.addEventListener('input', syncTextInput);
  syncTextInput();
});

// Weicher Rand an den Kachelreihen, solange dort noch etwas liegt.
(() => {
  const rows = document.querySelectorAll('.paws-font-row, .paws-panel.is-engraving .paws-grid');
  if (!rows.length) return;
  const sync = (row) => {
    const rest = row.scrollWidth - row.clientWidth;
    row.classList.toggle('has-more-left', rest > 4 && row.scrollLeft > 4);
    row.classList.toggle('has-more-right', rest > 4 && row.scrollLeft < rest - 4);
  };
  rows.forEach(row => {
    row.addEventListener('scroll', () => sync(row), { passive: true });
    // Die Reihe ist beim Laden noch unsichtbar und hat dann keine Breite.
    if (window.ResizeObserver) new ResizeObserver(() => sync(row)).observe(row);
    sync(row);
  });
})();

// Zusatz-Gravurzeilen: angeboten wird immer nur die naechste Zeile,
// entfernen laesst sich nur die zuletzt geoeffnete.
(() => {
  const rows = Array.prototype.slice.call(document.querySelectorAll('.js-text-line[data-collapsible]'));
  if (!rows.length) return;
  const rowOf = (line) => rows.find(r => r.dataset.line === line);
  const sync = () => {
    let offered = false;
    rows.forEach((row, i) => {
      const open = !row.hidden;
      const add = document.querySelector('.js-add-line[data-line="' + row.dataset.line + '"]');
      const rm = row.querySelector('.js-remove-line');
      if (add) {
        add.hidden = open || offered;
        if (!add.hidden) offered = true;
      }
      if (rm) rm.hidden = !open || (i < rows.length - 1 && !rows[i + 1].hidden);
    });
  };
  const toggle = (row, open) => {
    row.hidden = !open;
    row.querySelectorAll('input').forEach(el => { el.disabled = !open; });
    if (!open) {
      row.querySelectorAll('input[type="text"]').forEach(el => { el.value = ''; });
      const firstFont = row.querySelector('.js-font-row input[type="radio"]');
      if (firstFont) firstFont.checked = true;
    }
    sync();
    // Zaehler, Validierung und Gravur-Vorschau haengen alle am input-Event.
    const t = row.querySelector('input[type="text"]');
    if (t) t.dispatchEvent(new Event('input', { bubbles: true }));
    return t;
  };
  document.querySelectorAll('.js-add-line').forEach(btn => btn.addEventListener('click', () => {
    const row = rowOf(btn.dataset.line);
    if (!row) return;
    const t = toggle(row, true);
    // Auf Touch-Geraeten wuerde der Fokus sofort die Tastatur und den
    // Fokus-Modus aufziehen, ohne dass der Nutzer das angefordert hat.
    if (t && window.innerWidth > 991) t.focus();
  }));
  document.querySelectorAll('.js-remove-line').forEach(btn => btn.addEventListener('click', () => {
    const row = rowOf(btn.dataset.line);
    if (row) toggle(row, false);
  }));
  sync();
})();

// Gravur-Overlay: legt die Gravurzeilen ueber Galeriebilder, Thumbnails und Farbkacheln.
(() => {
  const cfgEl = document.getElementById('paws-preview-config');
  if (!cfgEl) return;
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (typeof cfg === 'string') { try { cfg = JSON.parse(cfg); } catch (e) { return; } }
  if (!cfg || typeof cfg !== 'object') return;

  const NS = 'http://www.w3.org/2000/svg';
  const XLINK = 'http://www.w3.org/1999/xlink';
  const num = (v, d) => (typeof v === 'number' && isFinite(v)) ? v : d;

  // Zeile 1 ist das bestehende Feld, danach folgen die Zusatzzeilen.
  const fields = [];
  const firstInput = document.querySelector('.js-paws-text-input');
  if (firstInput) fields.push({ input: firstInput, fallback: cfgEl.dataset.defaultText || '', fontSel: '.paws-panel[data-type="style"] .paws-grid input[type="radio"]:checked' });
  document.querySelectorAll('.js-paws-line-input').forEach(inp => {
    fields.push({ input: inp, fallback: inp.dataset.previewDefault || '', fontSel: '.js-font-row[data-line="' + inp.dataset.line + '"] input[type="radio"]:checked' });
  });
  if (!fields.length) return;

  // Geometrie je Zeile; "curve" ist der Durchhang in viewBox-Einheiten,
  // der Kontrollpunkt einer quadratischen Bezier liegt beim Doppelten.
  const lineDefaults = [{ y: 57, fontSize: 4.6, width: 32 }, { y: 60.9, fontSize: 3.1, width: 30 }, { y: 63.7, fontSize: 2.85, width: 36 }];
  const lineCfgs = Array.isArray(cfg.lines) ? cfg.lines : [];
  const geom = fields.map((f, i) => {
    const lc = lineCfgs[i] || {};
    const d = lineDefaults[i] || lineDefaults[lineDefaults.length - 1];
    const y = num(lc.y, d.y);
    const w = num(lc.width, d.width);
    const sag = num(lc.curve, num(cfg.curve, 0.15));
    const legacy = (i === 0 && typeof cfg.path === 'string') ? cfg.path.trim() : '';
    return {
      d: (typeof lc.path === 'string' && lc.path.trim()) || legacy ||
         'M ' + (50 - w / 2) + ',' + y + ' Q 50,' + (y + sag * 2) + ' ' + (50 + w / 2) + ',' + y,
      fontSize: num(lc.fontSize, d.fontSize),
      letterSpacing: num(lc.letterSpacing, num(cfg.letterSpacing, 0)),
      fontWeight: lc.fontWeight || cfg.fontWeight || '',
      fontStyle: lc.fontStyle || cfg.fontStyle || '',
      fill: num(lc.pathFill, num(cfg.pathFill, 0.98))
    };
  });

  // Gravurfarbe je Urnenfarbe; nicht gelistete Farben nutzen den Default.
  const colorMap = {};
  if (cfg.colors && typeof cfg.colors === 'object') {
    Object.keys(cfg.colors).forEach(k => { colorMap[normalizeColorKey(k)] = cfg.colors[k] || {}; });
  }
  const paintFor = (key) => {
    const c = colorMap[key] || {};
    return {
      // Der Default ist die am Produktfoto gemessene Multiply-Farbe und
      // wirkt daher nur bei voller Deckkraft wie die echte Gravur.
      color: c.color || cfg.color || '#666055',
      opacity: num(c.opacity, num(cfg.opacity, 1)),
      blend: c.blend || cfg.blend || 'multiply',
      lightColor: c.lightColor || cfg.lightColor || '#ffffff',
      lightOpacity: num(c.lightOpacity, num(cfg.lightOpacity, 0))
    };
  };

  // Die echte Gravur ist matt und ohne Relief - Rauheit und Versatz
  // sind daher standardmaessig aus und nur noch fein justierbar.
  const offset = num(cfg.offset, 0.22) * num(cfg.depth, 1);
  const roughness = num(cfg.roughness, 0);
  const baseBlur = num(cfg.blur, 0.02);
  const lightBlur = num(cfg.lightBlur, baseBlur * 2 + 0.02);
  // Ein Filter zwingt den Browser, den Text als Bitmap zu rastern - auf
  // Retina-Displays wirkt die Gravur dadurch unscharf. Unterhalb dieser
  // Schwelle ist der Weichzeichner ohnehin unsichtbar (< 0,2 px).
  const BLUR_SICHTBAR = 0.05;
  const brauchtFilter = (blur) => roughness > 0 || blur >= BLUR_SICHTBAR;

  let seq = 0;
  let ratio = 1;
  const overlays = [];

  const makeFilter = (defs, id, blur) => {
    const f = document.createElementNS(NS, 'filter');
    f.setAttribute('id', id);
    // Feste Region in viewBox-Einheiten: die BBox eines textPath-Textes
    // ist unbrauchbar und wuerde den Filter komplett leer rendern.
    f.setAttribute('filterUnits', 'userSpaceOnUse');
    f.setAttribute('x', '-20'); f.setAttribute('y', '-20');
    f.setAttribute('width', '140'); f.setAttribute('height', '240');
    f.setAttribute('color-interpolation-filters', 'sRGB');
    let last = 'SourceGraphic';
    if (roughness > 0) {
      const turb = document.createElementNS(NS, 'feTurbulence');
      turb.setAttribute('type', 'fractalNoise');
      turb.setAttribute('baseFrequency', String(num(cfg.roughnessScale, 1.4)));
      turb.setAttribute('numOctaves', '2');
      turb.setAttribute('seed', String(num(cfg.roughnessSeed, 7)));
      turb.setAttribute('result', id + 'n');
      f.appendChild(turb);
      const disp = document.createElementNS(NS, 'feDisplacementMap');
      disp.setAttribute('in', last);
      disp.setAttribute('in2', id + 'n');
      disp.setAttribute('scale', String(roughness));
      disp.setAttribute('xChannelSelector', 'R');
      disp.setAttribute('yChannelSelector', 'G');
      disp.setAttribute('result', id + 'd');
      f.appendChild(disp);
      last = id + 'd';
    }
    if (blur > 0) {
      const g = document.createElementNS(NS, 'feGaussianBlur');
      g.setAttribute('in', last);
      g.setAttribute('stdDeviation', String(blur));
      f.appendChild(g);
    }
    defs.appendChild(f);
    return 'url(#' + id + ')';
  };

  const createOverlay = (host, img, fillMode, colorKey) => {
    const uid = 'paws-eng-' + (++seq);
    const paint = paintFor(colorKey);
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'paws-engrave-svg' + (fillMode ? ' is-fill' : ''));
    svg.setAttribute('preserveAspectRatio', fillMode ? 'xMidYMid slice' : 'xMidYMid meet');
    svg.setAttribute('viewBox', '0 0 100 ' + (100 * ratio).toFixed(3));
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    const defs = document.createElementNS(NS, 'defs');
    const mainFilter = brauchtFilter(baseBlur) ? makeFilter(defs, uid + '-m', baseBlur) : '';
    const lightFilter = (paint.lightOpacity > 0 && brauchtFilter(lightBlur)) ? makeFilter(defs, uid + '-l', lightBlur) : '';
    svg.appendChild(defs);

    const lines = geom.map((g, i) => {
      const pathEl = document.createElementNS(NS, 'path');
      pathEl.setAttribute('id', uid + '-p' + i);
      pathEl.setAttribute('d', g.d);
      pathEl.setAttribute('fill', 'none');
      defs.appendChild(pathEl);

      const buildLayer = (fill, opacity, blend, dx, dy, filter) => {
        const text = document.createElementNS(NS, 'text');
        text.setAttribute('fill', fill);
        text.setAttribute('fill-opacity', String(opacity));
        text.setAttribute('text-anchor', 'middle');
        text.setAttribute('font-size', String(g.fontSize));
        text.setAttribute('letter-spacing', String(g.letterSpacing));
        if (g.fontWeight) text.setAttribute('font-weight', String(g.fontWeight));
        if (g.fontStyle) text.setAttribute('font-style', String(g.fontStyle));
        if (filter) text.setAttribute('filter', filter);
        if (dx || dy) text.setAttribute('transform', 'translate(' + dx + ' ' + dy + ')');
        text.style.mixBlendMode = blend;
        const tp = document.createElementNS(NS, 'textPath');
        tp.setAttribute('startOffset', '50%');
        tp.setAttribute('href', '#' + uid + '-p' + i);
        tp.setAttributeNS(XLINK, 'xlink:href', '#' + uid + '-p' + i);
        text.appendChild(tp);
        svg.appendChild(text);
        return { text: text, holder: tp };
      };

      const layers = [];
      if (paint.lightOpacity > 0) layers.push(buildLayer(paint.lightColor, paint.lightOpacity, 'screen', offset, offset, lightFilter));
      const main = buildLayer(paint.color, paint.opacity, paint.blend, 0, 0, mainFilter);
      layers.push(main);

      if (cfg.debug) {
        const p = pathEl.cloneNode(false);
        p.removeAttribute('id');
        p.setAttribute('class', 'paws-pv-debug');
        svg.appendChild(p);
      }
      return { pathEl: pathEl, layers: layers, main: main, fill: g.fill, fontSize: g.fontSize, letterSpacing: g.letterSpacing };
    });

    host.classList.add('paws-engrave-host');
    host.appendChild(svg);
    lines.forEach(verlaengern);
    const inst = { svg: svg, lines: lines, img: img, fillMode: fillMode, host: host, colorKey: colorKey };
    overlays.push(inst);
    return inst;
  };

  // SVG zeichnet auf einem <textPath> nur Glyphen, die innerhalb des Pfades
  // liegen; alles darueber hinaus faellt ersatzlos weg -- sichtbar als
  // fehlender erster oder letzter Buchstabe. Der Pfad wird deshalb an beiden
  // Enden tangential um seine eigene Laenge verlaengert. Weil das symmetrisch
  // geschieht, bleibt die Mitte (startOffset 50%) unveraendert; gerechnet wird
  // ab jetzt mit der gemerkten Originallaenge.
  const verlaengern = (ln) => {
    const p = ln.pathEl;
    const d = String(p.getAttribute('d') || '');
    if ((d.match(/[Mm]/g) || []).length !== 1) return;
    let base = 0;
    try { base = p.getTotalLength(); } catch (e) { return; }
    if (!(base > 0)) return;
    ln.baseLen = base;
    const s = Math.min(0.5, base / 50);
    const a0 = p.getPointAtLength(0), a1 = p.getPointAtLength(s);
    const b0 = p.getPointAtLength(base - s), b1 = p.getPointAtLength(base);
    const richtung = (von, nach) => {
      const dx = nach.x - von.x, dy = nach.y - von.y;
      const l = Math.sqrt(dx * dx + dy * dy) || 1;
      return [dx / l, dy / l];
    };
    const vor = richtung(a1, a0), zur = richtung(b0, b1);
    p.setAttribute('d', 'M ' + (a0.x + vor[0] * base) + ',' + (a0.y + vor[1] * base)
      + ' L ' + d.replace(/^\s*M\s*/i, '')
      + ' L ' + (b1.x + zur[0] * base) + ',' + (b1.y + zur[1] * base));
  };

  // Das Galeriebild fuellt sein Item nicht zwingend aus (max-height, Flex-Zentrierung).
  const syncBox = (inst) => {
    if (!inst || inst.fillMode || !inst.img) return;
    const s = inst.svg.style;
    s.left = inst.img.offsetLeft + 'px';
    s.top = inst.img.offsetTop + 'px';
    s.width = inst.img.offsetWidth + 'px';
    s.height = inst.img.offsetHeight + 'px';
  };

  const applyRatio = (img) => {
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    const next = img.naturalHeight / img.naturalWidth;
    if (Math.abs(next - ratio) < 0.001) return;
    ratio = next;
    overlays.forEach(o => o.svg.setAttribute('viewBox', '0 0 100 ' + (100 * ratio).toFixed(3)));
  };

  // Zu langer Text wird ueber die Schriftgroesse verkleinert, nicht ueber
  // textLength: auf einem <textPath> wenden Chrome und Safari textLength nicht
  // zuverlaessig an. Der Text bleibt dann laenger als der Pfad, und alle
  // Glyphen ausserhalb von [0, Pfadlaenge] werden ersatzlos weggelassen --
  // sichtbar als fehlendes erstes Zeichen. Ein kleinerer Schriftgrad passt
  // dagegen garantiert und verzerrt die Buchstaben auch nicht in die Breite.
  // Die Textlaenge ist in viewBox-Einheiten fuer alle Overlays identisch,
  // eine Messung an einem sichtbar gerenderten Exemplar genuegt also.
  const fitAll = () => {
    overlays.forEach(o => o.lines.forEach(ln => ln.layers.forEach(l => {
      l.text.removeAttribute('textLength');
      l.text.removeAttribute('lengthAdjust');
      l.text.setAttribute('font-size', String(ln.fontSize));
      l.text.setAttribute('letter-spacing', String(ln.letterSpacing));
    })));
    const probe = overlays.find(o => o.svg.clientWidth > 0);
    if (!probe) return;
    probe.lines.forEach((ln, i) => {
      const maxLen = (ln.baseLen || ln.pathEl.getTotalLength()) * ln.fill;
      let len = 0;
      try { len = ln.main.text.getComputedTextLength(); } catch (e) { return; }
      if (!(len > maxLen) || maxLen <= 0) return;
      const skalieren = (faktor) => overlays.forEach(o => {
        const z = o.lines[i];
        if (!z) return;
        z.layers.forEach(l => {
          l.text.setAttribute('font-size', String(z.fontSize * faktor));
          l.text.setAttribute('letter-spacing', String(z.letterSpacing * faktor));
        });
      });
      const faktor = maxLen / len;
      skalieren(faktor);
      // Glyphenbreiten skalieren durch Hinting und Rundung nicht exakt linear.
      try {
        const neu = ln.main.text.getComputedTextLength();
        if (neu > maxLen && neu > 0) skalieren(faktor * (maxLen / neu));
      } catch (e) {}
    });
  };

  // Die Schriftkacheln liegen in einem display:none-Panel; darin fordert der
  // Browser keine Webschrift an. Also je Familie genau einmal gezielt anstossen.
  const schriftPromises = new Map();
  const schriftLaden = (familie) => {
    if (!familie || !document.fonts || !document.fonts.load) return null;
    if (!schriftPromises.has(familie)) {
      schriftPromises.set(familie, document.fonts.load('16px ' + familie).catch(() => {}));
    }
    return schriftPromises.get(familie);
  };

  const renderText = () => {
    const state = fields.map(f => {
      let value = (f.input.disabled || f.input.hidden) ? '' : f.input.value.trim();
      if (!value && !f.input.disabled) value = f.fallback;
      if (value && cfg.uppercase) value = value.toUpperCase();
      gravurTexte.set(f.input, value);
      const checked = document.querySelector(f.fontSel);
      return { value: value, family: (checked && checked.dataset.font) || cfg.font || 'Times New Roman, Times, serif' };
    });
    overlays.forEach(o => o.lines.forEach((ln, i) => {
      const st = state[i];
      if (!st) return;
      ln.layers.forEach(l => {
        l.holder.textContent = st.value;
        l.text.setAttribute('font-family', st.family);
        l.text.style.display = st.value ? '' : 'none';
      });
    }));
    fitAll();
    // Solange die Webschrift noch laedt, misst fitAll() die Ersatzschrift.
    const warten = state.map(s => schriftLaden(s.family)).filter(Boolean);
    if (warten.length) Promise.all(warten).then(fitAll);
  };

  const fileKey = (url) => {
    if (!url) return '';
    try { return new URL(url, location.href).pathname.split('/').pop().toLowerCase(); } catch (e) { return ''; }
  };
  const altColorKey = (alt) => {
    const raw = (alt || '').trim();
    const at = raw.toLowerCase().indexOf('farbe:');
    return normalizeColorKey(at === -1 ? raw : raw.slice(at + 6).split('|')[0]);
  };

  // Hinweis, dass die Vorschau nur eine Darstellung ist.
  const addNote = (host) => {
    const text = cfgEl.dataset.note;
    if (!text || host.querySelector('.paws-engrave-note')) return;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'paws-engrave-note';
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg><span class="paws-engrave-note-text"></span>';
    b.querySelector('.paws-engrave-note-text').textContent = text;
    b.setAttribute('aria-label', text);
    b.addEventListener('click', (e) => { e.preventDefault(); b.classList.toggle('is-open'); });
    host.appendChild(b);
  };

  // Graviert wird nur auf den Bildern, die zu einer Konfigurator-Farbe
  // gehoeren - Detail- und Stimmungsbilder bleiben unberuehrt.
  const attachAll = () => {
    if (overlays.length) return;
    const colorKeys = new Set(Array.prototype.map.call(document.querySelectorAll('.js-color-trigger'), r => normalizeColorKey(r.value)));
    let items = Array.prototype.slice.call(document.querySelectorAll('.ext-gallery-item'));
    if (colorKeys.size) items = items.filter(it => colorKeys.has(altColorKey(it.dataset.mediaAlt)));
    if (!items.length) return;

    const files = new Map();
    items.forEach(it => {
      const img = it.querySelector('img');
      if (!img) return;
      const key = altColorKey(it.dataset.mediaAlt);
      files.set(fileKey(img.getAttribute('src')), key);
      const inst = createOverlay(it, img, false, key);
      addNote(it);
      const onLoad = () => { applyRatio(img); syncBox(inst); fitAll(); };
      if (img.complete) onLoad();
      img.addEventListener('load', onLoad);
      if (window.ResizeObserver) new ResizeObserver(() => syncBox(inst)).observe(img);
    });
    document.querySelectorAll('.ext-thumb-btn').forEach(btn => {
      const img = btn.querySelector('img');
      const key = img && files.get(fileKey(img.getAttribute('src')));
      if (key !== undefined) createOverlay(btn, img, true, key);
    });
    document.querySelectorAll('.paws-swatch-item label').forEach(label => {
      const m = label.style.backgroundImage.match(/url\(["']?([^"')]+)["']?\)/);
      const key = m && files.get(fileKey(m[1]));
      if (key !== undefined) createOverlay(label, null, true, key);
    });
    renderText();
  };

  fields.forEach(f => {
    f.input.addEventListener('input', renderText);
    f.input.addEventListener('focus', () => document.documentElement.classList.add('paws-input-focus'));
    f.input.addEventListener('blur', () => document.documentElement.classList.remove('paws-input-focus'));
  });
  document.querySelectorAll('.paws-panel[data-type="style"] .paws-grid input[type="radio"], .js-font-row input[type="radio"]').forEach(r => r.addEventListener('change', renderText));
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

  // Alle waehlbaren Schriften im Leerlauf nachholen: die Kacheln im noch
  // versteckten Schritt sollen beim Aufklappen fertig aussehen, ohne dass der
  // Download mit dem ersten Bild um Bandbreite konkurriert.
  const schriftenVorwaermen = () => {
    const namen = new Set();
    document.querySelectorAll('.paws-panel[data-type="style"] .paws-grid input[data-font], .js-font-row input[data-font]')
      .forEach(r => { if (r.dataset.font) namen.add(r.dataset.font); });
    const warten = [...namen].map(n => schriftLaden(n)).filter(Boolean);
    if (warten.length) Promise.all(warten).then(fitAll);
  };
  const nachLaden = () => {
    if ('requestIdleCallback' in window) requestIdleCallback(schriftenVorwaermen, { timeout: 3000 });
    else setTimeout(schriftenVorwaermen, 1200);
  };
  if (document.readyState === 'complete') nachLaden();
  else window.addEventListener('load', nachLaden, { once: true });

  window.addEventListener('resize', () => { overlays.forEach(o => syncBox(o)); fitAll(); });
  document.addEventListener('paws:gallery-ready', attachAll);
  attachAll();

  // ---------------------------------------------------------------------
  // Schnappschuss fuer die Bestellung
  // ---------------------------------------------------------------------
  // Beim Kauf wird das Produktbild der GEWAEHLTEN Farbe zusammen mit den
  // Gravurzeilen in eine JPEG-Datei gerendert und als Line-Item-Property an
  // die Bestellzeile gehaengt. Die Fertigung sieht damit genau das, was der
  // Kunde vor sich hatte.
  //
  // Aktivierung: automatisch fuer jedes Produkt mit gueltigem
  // `custom.configurator_preview` - dasselbe Metafeld, das die Live-Vorschau
  // ueberhaupt erst einschaltet. Ein weiteres Metafeld braucht es nicht.
  // Feinsteuerung im SELBEN JSON, alles optional:
  //   "snapshot": false                      -> abschalten
  //   "snapshot": { "property": "bild1",     -> Name der Line-Item-Property
  //                 "width": 1400,           -> max. Kantenlaenge in Pixeln
  //                 "quality": 0.9 }         -> JPEG-Guete
  const snapCfg = (cfg.snapshot === false || cfg.snapshot === null) ? null
    : (cfg.snapshot && typeof cfg.snapshot === 'object' ? cfg.snapshot : {});

  if (snapCfg) {
    const SNAP_PROP = (typeof snapCfg.property === 'string' && snapCfg.property.trim()) || 'bild1';
    const SNAP_BREITE = Math.max(320, Math.min(2048, Math.round(num(snapCfg.width, 1400))));
    const SNAP_GUETE = Math.max(0.5, Math.min(1, num(snapCfg.quality, 0.9)));
    const MISCH = { multiply: 'multiply', screen: 'screen', overlay: 'overlay', normal: 'source-over' };

    const bildLaden = (src) => new Promise((fertig, fehler) => {
      const im = new Image();
      im.decoding = 'async';
      // Nur bei fremder Herkunft noetig; sonst zwingt das Attribut den Browser
      // unnoetig zu einem zweiten Download (CORS-Anfragen haben einen eigenen Cache).
      try { if (new URL(src, location.href).origin !== location.origin) im.crossOrigin = 'anonymous'; } catch (e) {}
      im.onload = () => fertig(im);
      im.onerror = () => fehler(new Error('Bild nicht ladbar'));
      im.src = src;
    });

    // Shopify liefert nie hoch skaliert - ein zu grosser Wunsch gibt schlicht das Original.
    const grossURL = (src) => {
      try {
        const u = new URL(src, location.href);
        if (u.searchParams.has('width')) u.searchParams.set('width', String(SNAP_BREITE));
        return u.href;
      } catch (e) { return src; }
    };

    // Ein als Bild geladenes SVG darf keine externen Dateien nachladen - die
    // Gravurschrift muss also als Data-URI mit hinein, sonst raetselt der
    // Renderer eine Ersatzschrift zusammen.
    const b64 = (buf) => {
      const bytes = new Uint8Array(buf);
      let s = '';
      for (let i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
      return btoa(s);
    };
    const schriftCache = new Map();
    const schriftRegel = (familie) => {
      const name = String(familie || '').split(',')[0].trim().replace(/^["']|["']$/g, '');
      if (!name) return Promise.resolve('');
      if (!schriftCache.has(name)) {
        let url = '';
        Array.prototype.forEach.call(document.styleSheets, (sheet) => {
          if (url) return;
          let rules;
          try { rules = sheet.cssRules; } catch (e) { return; } // fremde Herkunft
          if (!rules) return;
          Array.prototype.forEach.call(rules, (rule) => {
            if (url || !rule || rule.type !== 5 /* CSSRule.FONT_FACE_RULE */) return;
            const fam = (rule.style.getPropertyValue('font-family') || '').trim().replace(/^["']|["']$/g, '');
            if (fam.toLowerCase() !== name.toLowerCase()) return;
            const m = (rule.style.getPropertyValue('src') || '').match(/url\(["']?([^"')]+)["']?\)/);
            if (m) url = m[1];
          });
        });
        schriftCache.set(name, !url ? Promise.resolve('') : fetch(url)
          .then(r => r.ok ? r.arrayBuffer() : Promise.reject(new Error('HTTP ' + r.status)))
          .then(buf => '@font-face{font-family:"' + name + '";src:url(data:font/woff2;base64,' + b64(buf) + ') format("woff2");}')
          .catch(() => ''));
      }
      return schriftCache.get(name);
    };

    const sichtbareTexte = (svg) => Array.prototype.filter.call(
      svg.querySelectorAll('text'),
      t => t.style.display !== 'none' && String(t.textContent).trim() !== ''
    );

    // Reihenfolge der Mischgruppen = Reihenfolge im SVG (erst Lichtschicht, dann Gravur).
    const mischGruppen = (inst) => {
      const liste = [];
      sichtbareTexte(inst.svg).forEach(t => {
        const b = t.style.mixBlendMode || 'normal';
        if (liste.indexOf(b) === -1) liste.push(b);
      });
      return liste;
    };

    const schichtBild = async (inst, blend, breite, hoehe) => {
      const klon = inst.svg.cloneNode(true);
      klon.setAttribute('width', String(breite));
      klon.setAttribute('height', String(hoehe));
      klon.setAttribute('xmlns', NS);
      klon.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', XLINK);
      klon.removeAttribute('class');
      klon.style.cssText = '';
      const familien = new Set();
      let behalten = 0;
      Array.prototype.forEach.call(klon.querySelectorAll('text'), (t) => {
        const eigen = t.style.mixBlendMode || 'normal';
        if (eigen !== blend || t.style.display === 'none' || String(t.textContent).trim() === '') { t.remove(); return; }
        t.style.mixBlendMode = ''; // gemischt wird auf der Leinwand, nicht im SVG
        familien.add(t.getAttribute('font-family') || '');
        behalten++;
      });
      if (!behalten) return null;
      const css = (await Promise.all([...familien].map(schriftRegel))).join('');
      if (css) {
        const st = document.createElementNS(NS, 'style');
        st.textContent = css;
        klon.insertBefore(st, klon.firstChild);
      }
      const quelltext = new XMLSerializer().serializeToString(klon);
      return bildLaden('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(quelltext));
    };

    // Ueberschreitet ein Foto die Speichergrenze der Leinwand, meldet der
    // Browser KEINEN Fehler, sondern liefert eine leere Flaeche. Ein
    // reinweisses "Ergebnis" wuerde unbemerkt in die Fertigung gehen.
    const leinwandGefuellt = (stift, breite, hoehe) => {
      try {
        const punkte = [[0.5, 0.5], [0.25, 0.35], [0.75, 0.35], [0.25, 0.75], [0.75, 0.75]];
        const werte = punkte.map(([x, y]) => {
          const d = stift.getImageData(Math.floor(breite * x), Math.floor(hoehe * y), 1, 1).data;
          return d[0] + ',' + d[1] + ',' + d[2];
        });
        return new Set(werte).size > 1;
      } catch (e) {
        return true; // Messung nicht moeglich -> Bild nicht verwerfen
      }
    };

    const zielOverlay = () => {
      const kandidaten = overlays.filter(o => !o.fillMode && o.img);
      if (!kandidaten.length) return null;
      const gewaehlt = document.querySelector('.js-color-trigger:checked');
      const key = gewaehlt ? normalizeColorKey(gewaehlt.value) : '';
      return (key && kandidaten.find(o => o.colorKey === key)) || kandidaten[0];
    };

    // Liefert die fertige Datei oder null. Wirft nie - ein Kauf darf an der
    // Vorschau nicht scheitern.
    window.pawsGravurBild = async () => {
      const inst = zielOverlay();
      if (!inst || !inst.img) return null;
      const foto = await bildLaden(grossURL(inst.img.currentSrc || inst.img.src));
      const bw = foto.naturalWidth || foto.width;
      const bh = foto.naturalHeight || foto.height;
      if (!bw || !bh) return null;

      // viewBox und Schriftgroessen exakt auf dieses Bild ausrichten.
      applyRatio(foto);
      fitAll();

      const breite = Math.min(SNAP_BREITE, bw);
      const hoehe = Math.max(1, Math.round(breite * bh / bw));
      const leinwand = document.createElement('canvas');
      leinwand.width = breite;
      leinwand.height = hoehe;
      const stift = leinwand.getContext('2d');
      stift.imageSmoothingQuality = 'high';
      stift.fillStyle = '#ffffff';
      stift.fillRect(0, 0, breite, hoehe);
      stift.drawImage(foto, 0, 0, breite, hoehe);

      for (const blend of mischGruppen(inst)) {
        const schicht = await schichtBild(inst, blend, breite, hoehe);
        if (!schicht) continue;
        stift.globalCompositeOperation = MISCH[blend] || 'source-over';
        stift.drawImage(schicht, 0, 0, breite, hoehe);
      }
      stift.globalCompositeOperation = 'source-over';

      if (!leinwandGefuellt(stift, breite, hoehe)) return null;
      const blob = await new Promise(f => leinwand.toBlob(f, 'image/jpeg', SNAP_GUETE));
      leinwand.width = leinwand.height = 0;
      if (!blob) return null;
      return new File([blob], 'gravur-vorschau.jpg', { type: 'image/jpeg' });
    };
    window.pawsGravurBildName = SNAP_PROP;
  }
})();

document.querySelectorAll('input, select, textarea').forEach(el => el.addEventListener('change', (e) => { 
  validatePanel();
  if (!window.pawsWiederherstellung && !einseitig && !CONFIG.isAutoNextDisabled && el.classList.contains('js-auto-next') && !CONFIG.noAutoNextSteps.includes(el.closest('.js-panel').dataset.type) && !el.closest('.js-panel').dataset.type.includes('phones') && !el.closest('.js-panel').dataset.type.includes('page-upsell') && !el.closest('.js-panel').querySelector('.js-btn-next').disabled) {
    setTimeout(() => { if (currentIdx < panels.length - 1) { currentIdx++; render(true, 1); } }, 450);
  }
  if (e.target.classList.contains('js-finish-input')) {
    for (const h in upsellMapping) if (upsellMapping[h] && upsellMapping[h].configurator_page_upsell) selectedUpsells.delete(h);
    // V189: Use dynamic name in JS selector
    // Ohne Groessen-Option gibt find() undefined zurueck - ensureDefaultSelection
    // wuerde dann ALLE Panels zuruecksetzen und die eben getroffene Wahl kippen.
    const sizePanel = panels.find(p => p.querySelector(`input[name="options[${OPT_NAMES.size}]"]`));
    if (sizePanel) {
      document.querySelectorAll(`input[name="options[${OPT_NAMES.size}]"]`).forEach(r => r.checked = false);
      const allowed = vMap[e.target.value] || []; let vis = 0;
      document.querySelectorAll('.js-size-card').forEach(c => { const ok = allowed.includes(c.dataset.sizeVal); c.style.display = ok ? 'block' : 'none'; if (ok) vis++; });
      const grid = document.querySelector('.js-size-grid-container'); if (grid) grid.style.gridTemplateColumns = (vis === 2 || vis === 4) ? '1fr 1fr' : '1fr 1fr 1fr';
      // V189: Use dynamic name in JS finder
      ensureDefaultSelection(sizePanel, true);
    }
  }
  if (e.target.classList.contains('js-anz-trigger')) updatePetFields();
  if (e.target.classList.contains('js-color-trigger')) showMediaForSelectedColor();
  if (e.target.classList.contains('js-file-in')) {
    const datei = e.target.files[0];
    fotoErsatz.delete(e.target);
    fotoArbeit.delete(e.target);
    if (datei) {
      zeigeFotoVorschau(e.target.closest('.js-pet-card'), datei);
      fotoVorbereiten(e.target, datei);
    }
  }
  
  // V159: Brand Update Logic
  if (e.target.classList.contains('js-brand-trigger')) {
     renderPhoneOptions(e.target.value);
     document.querySelector('.js-final-brand-input').value = e.target.dataset.brandName;
  }

  // V172: HIDE ERROR ON SELECTION
  if (e.target.classList.contains('js-model-selector')) {
       document.getElementById('paws-phone-error-msg').style.display = 'none';
  }

  // V186: UPDATE BG SKU HIDDEN FIELDS
  if (e.target.classList.contains('js-bg-trigger')) {
       document.querySelector('.js-bg-sku-size').value = e.target.dataset.skuSize || "";
       document.querySelector('.js-bg-sku-style').value = e.target.dataset.skuStyle || "";
  }
  
  updatePrice();
  updateFinalSku(); // V161: Update SKU on any change
  updateFinalModel(); // V163: Sync Model Dropdown
  renderDebugProperties(); // V160: Trigger Debug Update

  // Variante B: welche Zusatzangebote passen und was in der
  // Zusammenfassung steht, haengt an der gewaehlten Variante. In
  // Variante A zieht das der Schrittwechsel nach - hier gibt es keinen.
  if (einseitig) renderEinseitig(false);

  const feld = e.target;
  if (feld && feld.closest && feld.closest('#paws-configurator-wrapper') && !window.pawsWiederherstellung) {
    // Freitexte (Namen, Daten, Dateien) werden nie uebertragen.
    const istFrei = feld.tagName === 'TEXTAREA' || ['text', 'file', 'date', 'email', 'tel'].includes(feld.type);
    const rohName = feld.name || '';
    const panelEl = feld.closest('.js-panel');
    const idx = panelEl ? panels.indexOf(panelEl) : currentIdx;
    track('configurator_option', Object.assign(schrittInfo(idx >= 0 ? idx : currentIdx), {
      option_name: rohName.replace(/^(options|properties)\[/, '').replace(/\]$/, '') || feld.dataset.trackName || 'unbenannt',
      option_value: istFrei ? (feld.value ? 'ausgefuellt' : 'leer') : String(feld.value || '').slice(0, 60),
      option_scope: rohName.indexOf('options[') === 0 ? 'variante' : 'eigenschaft',
      input_type: feld.tagName === 'SELECT' ? 'select' : (feld.type || 'input')
    }));
  }
}));

document.addEventListener('input', (e) => {
   if (e.target.classList.contains('js-auto-expand')) {
      const stil = getComputedStyle(e.target);
      e.target.style.height = 'auto';
      // scrollHeight misst die Padding-Box; das Feld rechnet in border-box.
      // Ohne die Rahmen bleibt die letzte Zeile um 2px angeschnitten.
      e.target.style.height = (e.target.scrollHeight + parseFloat(stil.borderTopWidth) + parseFloat(stil.borderBottomWidth)) + 'px';
   }
   renderDebugProperties(); // V160: Trigger Debug Update (Text Input)
});

// Ein Platzhalter geht nicht in scrollHeight ein, das Auto-Wachsen oben greift
// also erst beim Tippen. Passt er nicht in eine Zeile, wuerde er abgeschnitten
// (overflow:hidden) - darum seine Breite einmal selbst messen. Die Hoehe stellt
// "rows" - ein fester Pixelwert wuerde bei geerbter Zeilenhoehe danebenliegen.
const platzhalterZeilenPruefen = (feld) => {
  const stil = getComputedStyle(feld);
  const platz = feld.clientWidth - parseFloat(stil.paddingLeft) - parseFloat(stil.paddingRight);
  if (!feld.placeholder || !(platz > 0)) return;
  const mess = document.createElement('span');
  mess.textContent = feld.placeholder;
  mess.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;white-space:nowrap';
  mess.style.fontFamily = stil.fontFamily;
  mess.style.fontSize = stil.fontSize;
  mess.style.fontWeight = stil.fontWeight;
  mess.style.fontStyle = stil.fontStyle;
  mess.style.letterSpacing = stil.letterSpacing;
  document.body.appendChild(mess);
  const textBreite = mess.getBoundingClientRect().width;
  mess.remove();
  feld.rows = textBreite > platz ? 2 : 1;
  if (feld.value === '') feld.style.height = '';
};

document.querySelectorAll('textarea.js-auto-expand[placeholder]').forEach(feld => {
  platzhalterZeilenPruefen(feld);
  if (!window.ResizeObserver) return;
  // Im ausgeblendeten Panel ist die Breite 0; der Beobachter liefert sie nach,
  // sobald das Feld sichtbar wird. Der Breitenvergleich haelt ihn schleifenfrei.
  let letzteBreite = feld.clientWidth;
  new ResizeObserver(() => {
    if (feld.clientWidth === letzteBreite) return;
    letzteBreite = feld.clientWidth;
    platzhalterZeilenPruefen(feld);
  }).observe(feld);
});

document.querySelectorAll('.js-trigger-upload').forEach(box => {
    box.addEventListener('click', () => {
        const input = box.closest('.paws-upload-card').querySelector('.js-file-in');
        if(input) input.click();
    });
});

// Ein Aufruf mit ?variant=... (Google Shopping, Warenkorb, geteilter Link)
// soll die zugehoerigen Kacheln vorwaehlen. Laeuft vor der Standardauswahl
// und nur einmal, damit eine bereits getroffene Wahl nie ueberschrieben wird.
let urlVarianteGeprueft = false;
const uebernehmeUrlVariante = () => {
  if (urlVarianteGeprueft) return;
  urlVarianteGeprueft = true;
  if (!Array.isArray(OPT_ALL) || !Array.isArray(vData)) return;
  let id = null;
  try { id = new URLSearchParams(window.location.search).get('variant'); } catch (e) { return; }
  if (!id) return;
  const ziel = vData.find(v => String(v.id) === String(id));
  if (!ziel || !Array.isArray(ziel.options)) return;
  const radios = [...document.querySelectorAll('#paws-configurator-wrapper input[type="radio"][name^="options["]')];
  OPT_ALL.forEach((name, idx) => {
    const wert = ziel.options[idx];
    if (wert === undefined || wert === null) return;
    const gruppe = radios.filter(r => r.name === `options[${name}]`);
    const treffer = gruppe.find(r => r.value === String(wert));
    if (!treffer || treffer.checked) return;
    gruppe.forEach(r => { r.checked = false; });
    treffer.checked = true;
  });
};

const init = () => {
  uebernehmeUrlVariante();
  // V189: DYNAMIC SELECTORS
  const f = document.querySelector(`input[name="options[${OPT_NAMES.variant}]"]:checked`)?.value;
  const allowed = vMap[f] || []; let vis = 0;
  document.querySelectorAll('.js-size-card').forEach(c => { const ok = !f || allowed.includes(c.dataset.sizeVal); c.style.display = ok ? 'block' : 'none'; if (ok) vis++; });
  const grid = document.querySelector('.js-size-grid-container'); if (grid) grid.style.gridTemplateColumns = (vis === 2 || vis === 4) ? '1fr 1fr' : '1fr 1fr 1fr';
  
  const initialBrand = document.querySelector('.js-brand-trigger:checked');
  if (initialBrand) { 
     renderPhoneOptions(initialBrand.value); 
     // V159: Init Brand Name
     document.querySelector('.js-final-brand-input').value = initialBrand.dataset.brandName;
  }

  // V186: INIT BG SKU
  const initialBg = document.querySelector('.js-bg-trigger:checked');
  if (initialBg) {
     document.querySelector('.js-bg-sku-size').value = initialBg.dataset.skuSize || "";
     document.querySelector('.js-bg-sku-style').value = initialBg.dataset.skuStyle || "";
  }

  ensureDefaultSelection(); updatePetFields(); updatePrice(); 
  bestsellerTextSetzen(); // Beschriftung des Eckbands, einmal je Seite
  updateFinalSku(); // V161: Init SKU
  updateFinalModel(); // V163: Init Model
  renderDebugProperties(); // V160: Init Debug
  lieferzeitTrennen();
  garantieAufbauen();
  // Das globale Badge steht serverseitig im Markup, ein Versuch reicht
  // in aller Regel. Der zweite deckt spaet nachgeladene Faelle ab.
  if (!vertrauenUebernehmen()) setTimeout(vertrauenUebernehmen, 1200);
  colorMediaMap = buildColorMediaMap();
  showMediaForSelectedColor(true);
  // dir 0 statt 1: der Aufbau ist kein Schrittwechsel und wird als
  // direction "start" gemeldet, sonst zaehlt GA4 ihn wie einen Weiter-Klick.
  render(false, 0);
};
init(); setTimeout(init, 500);

// Schnittstelle fuer assets/paws-resume.js ("Weitermachen, wo du aufgehoert hast").
// Dateien bleiben aussen vor, die lassen sich nicht zurueckschreiben; die
// Zusatzprodukte kommen ueber selectedUpsells statt ueber die Ankreuzfelder,
// weil deren Markup bei jedem Rendern neu aus diesem Set gebaut wird.
window.pawsKonfigurator = {
  felder: () => [...master.querySelectorAll('input[name], select[name], textarea[name]')]
    .filter(el => el.type !== 'file' && !el.disabled && !el.classList.contains('js-upsell-checkbox') && !el.classList.contains('js-page-upsell-radio')),
  schrittIndex: () => {
    if (!einseitig) return currentIdx;
    // Variante B kennt keinen aktiven Schritt - massgeblich ist, was
    // gerade oben im Blickfeld steht.
    const grenze = (window.innerHeight || 0) * 0.35;
    let treffer = 0;
    panels.forEach((p, i) => { if (p.getBoundingClientRect().top <= grenze) treffer = i; });
    return treffer;
  },
  schrittAnzahl: () => panels.length,
  schrittName: (i) => schrittInfo(i).step_name,
  geheZu: (i) => {
    const ziel = Math.max(0, Math.min(panels.length - 1, i));
    if (einseitig) {
      const p = panels[ziel];
      if (!p) return;
      const oben = (window.pawsStickyTopOffset ? window.pawsStickyTopOffset() : 0) || 130;
      window.scrollTo({ top: p.getBoundingClientRect().top + window.pageYOffset - oben - 12, behavior: 'smooth' });
      return;
    }
    currentIdx = ziel;
    render(true, 0);
  },
  upsells: () => [...selectedUpsells],
  upsellsSetzen: (liste) => {
    const alle = liste || [];
    // Solange die Zusatzprodukte noch laden, laesst sich nichts pruefen.
    const geladen = upsellMapping && Object.keys(upsellMapping).length;
    selectedUpsells = new Set(geladen ? alle.filter(h => upsellMapping[h]) : alle);
    updatePrice();
  },
  // Hinter einen Schritt, in dem noch ein Foto fehlt, darf niemand springen.
  grenzeIndex: () => panels.findIndex(p => [...p.querySelectorAll('input[type="file"]')].some(f => !f.disabled && f.files.length === 0))
};
      })();
